import { QryFuncModal } from "../../../components/qryFunc";
import { isShipmentFromEngine } from "../../../util/index";
import get from "lodash/get";
import isEqual from "lodash/isEqual";
import React from 'react';
import { confirmAlert } from "react-confirm-alert";
import { connect } from 'react-redux';
import { Button, Checkbox, Dropdown, Grid, Icon, Loader, Modal, Popup } from 'semantic-ui-react';
import { chinaExlcusionHTSTriggers, fillEmptyMetalCountries, formatHTS, getDutyComputationCode, getTotalChapter91EnteredValue, hasChapter91Duties, isCommodityHtsChapter, isEnteredValueDisabled, shouldMakeHTSAPICall, shouldUseChapter91ForCh99 } from "../../../CBP_App/util";
import { toast } from "../../../commonComponents/Toast";
import CopyToClipboard from "../../../commonComponents/copyToClipboard";
import HTSCodePopup from '../../HTSWidget/HTSCodePopup';
import * as actionCreators from '../../actions';
import { createMerchandiseDutyItem } from '../../api/createItem';
import { deleteAdCvdFormData } from '../../api/deleteFormData';
import { deleteUnusedPGAS, getHSDtlList } from "../../api/htsRequests";
import { HttpPostRequest } from '../../api/setFormData';
import { isTargetApp } from '../../api/util';
import PopUpIcon from '../../formComponents/PopUpIcon';
import InputField from '../../formComponents/inputField';
import SelecTextField from '../../formComponents/selectTextField';
import { ch82SetHtses, hasanyvaluesAdcvd, isWarehouseEntry, propsAreEqual_NoRerenderNeeded, formValuesTargetThisMerchandiseLine } from '../../reducer/util';
import { selectInvoiceByIndex, selectMerchandiseDutyByIndex, selectMerchandiseLineItemByIndex, selectUseAggregated } from '../../selectors/merchandiseSelectors';
import { selectMerchandiseDutyValidation } from '../../selectors/validationSelectors';
import { DutyItemFields } from '../../util/supportedFields/descriptionOfMerchandise';
import { shouldAlignUomToExpected } from "../../util/uomAlignment";
import { triggerFormValidationSoon } from '../../validation/triggerFormValidation';
import AdditionDeductionMechLevel from '../AdditionDeduction/AdditionDeductionMechLevel';
import UpdateTariffs from '../UpdateTariffs';
import { getPopUpIcon } from '../util';
import { isLineItemIoLazyLoadEnabled } from './lineItemFeatureFlags';
import { getAluminumMeltAndPourCodes, getCopperSmeltAndCastCodes, getExclusionHTSES, getSteelMeltAndPourCodes, isMeltSmeltCastExemptCOO, russiaMetaData, showNetQtyOrCbpQty1, subExclusionHTSES } from '../util/constants';

function coerceBlurQuantity(value, fallback) {
  if (value == null || typeof value === 'object') return fallback;
  const cleaned = String(value).replace(/[^\d.-]/g, '');
  if (!cleaned || cleaned === '-' || cleaned === '.') return fallback;
  const n = parseFloat(cleaned);
  return Number.isFinite(n) ? cleaned : fallback;
}

const confirmUomMismatch = ({ label, expected, got, onKeep, onSetExpected }) => {
  confirmAlert({
    title: `${label} mismatch`,
    message: `Expected UOM is '${expected}', but you selected '${got || "NONE"}'. Do you want to keep your selection or set it to the expected UOM?`,
    buttons: [
      { label: "Keep my selection", onClick: onKeep },
      { label: "Set expected UOM", onClick: onSetExpected },
    ],
  });
};

export const changeEnteredValueDutyLevel = (value,
  lineItemIndex,
  invoiceItemIndex,
  index, thisprops, allDuties, saveafterwards, actualField, callback) => {
  let { shipmentId } = thisprops;
  if (thisprops.launchFrom === 'PRODUCT_HISTORY') {
    return;
  }
  // Only perform changes if the field was touched (value was edited)
  thisprops.updateMerchDutyItemFeild(
    invoiceItemIndex,
    lineItemIndex,
    index,
    "enteredValue",
    parseFloat(value || 0).toFixed(2)
  );

  thisprops.handleDutyItemContextSwitch(
    lineItemIndex,
    invoiceItemIndex,
    index
  );
  // action for updating invoice amount

  // Update Tital Value
  thisprops.updateTotalValueAndGrossWeight();

  if (saveafterwards) {


    let saveCall = thisprops.saveMerchDutyItem(
      lineItemIndex,
      invoiceItemIndex,
      index,
      "enteredValue",
      value,
      "",
      callback,
      actualField,
    );

    allDuties.forEach((item, dutyIndex) => {
      setTimeout(() => {
        if (item.isCommodityDuty != 1) {
          thisprops.saveMerchDutyItem(
            lineItemIndex,
            invoiceItemIndex,
            dutyIndex,
            "dutyRate"
          );
        }
      }, dutyIndex * 1000)
    });
    setTimeout(() => {
      if (localStorage.getItem("disableAutoCalculate") == 'true') {

      } else {
        document.getElementById(`recalculateLineItemWeights${shipmentId}`) && document.getElementById(`recalculateLineItemWeights${shipmentId}`).click();
      }
    }, 2500)
    return saveCall;
  }
  return new Promise((resolve, reject) => {
    resolve({});
  });
}

export const saveWholeInvoiceEnteredValue = (thisprops, invoiceItemIndex, shipmentId) => {

  for (let iiii of [1]) {
    setTimeout(() => {
      thisprops.saveWholeInvoice(
        invoiceItemIndex,
        ["htsus", "enteredValue", "isCommodityDuty", "dutyRate"]
      );
    }, 400 * iiii);
  }
  setTimeout(() => {
    if (localStorage.getItem("disableAutoCalculate") == 'true') {

    } else {
      let recalcButton = document.getElementById(`recalculateLineItemWeights${shipmentId}`);
      if (recalcButton && ((recalcButton.getAttribute("lastClickCCCC") || 0) < Date.now() - 1000)) {

        recalcButton.setAttribute("lastClickCCCC", Date.now());
        recalcButton.click();
      }
    }
  }, 1500)
}

export const hasanyoverrideflag = (allDuties) => {
  if (!allDuties) return false;
  for (let oneduty of allDuties) {
    if (oneduty.dutyOverrideFlag == 1) {
      return true;
    }
  }
  return false
}

export const hasDutyOverride = (oneduty, merchandiseDuties) => {
  let hasAnyNinetyEightDuty = false;
  for (let onedutyXX of merchandiseDuties || []) {
    if (onedutyXX && onedutyXX.htsus) {
      if (onedutyXX.htsus.slice(0, 2) == "98") hasAnyNinetyEightDuty = true;
      if (onedutyXX.htsus.slice(0, 4) == "9802") hasAnyNinetyEightDuty = false;
      if (onedutyXX.htsus.replace(/\./g, "") == "99039008") hasAnyNinetyEightDuty = true;
    }
  }
  let htsChapter = parseInt((oneduty.htsus || "")?.slice(0, 2))
  const isNinetyNineDuty = htsChapter == "99"

  let isCommodityHTS = isCommodityHtsChapter(htsChapter);
  let isCommodityDutyBoolean = oneduty.isCommodityDuty === 1;

  return (isNinetyNineDuty || isCommodityDutyBoolean) && hasAnyNinetyEightDuty;
}

class DutyItem extends React.Component {


  constructor(props) {
    super(props)
    this.containerRef = React.createRef(); // ✅ Define the ref in constructor
    this.observer = null;
    this.dutyContentLoaded = !!props?.defaultVisible || !isLineItemIoLazyLoadEnabled();

    this.state = {
      visible: this.props?.defaultVisible || !isLineItemIoLazyLoadEnabled(),
      formInfo: {},
      expanded: true,
      isDeletingHTS: false,
      hts: props?.htsus?.replace(/\./g, '') || "",
      showhtspopup: false,
      htsError: 200,
      htsHasBeenLengthZero: !(props?.htsus?.replace(/\./g, '') || "")?.length,
      isUnitPriceUpdating: false,
      isINVQtyUpdating: false,
      previousEnteredValue: false,
      previousAdditionalQuantity: false
    }
    for (let key in DutyItemFields) {
      DutyItemFields[key].errors = []
      DutyItemFields[key].valid = []
    }
    this.addErrorClass.bind(this)
    this.removeErrorClass.bind(this)
    this.validateField.bind(this)
    this.getValidationBasedOnHts.bind(this)
    this.inputRef = React.createRef();
  }

  // Helper function to update ch82BuilderHash state
  updateCh82BuilderHash = (dutyId, updates, additionalState = {}) => {
    this.setState(prevState => ({
      ch82BuilderHash: prevState.ch82BuilderHash.map(item =>
        item.merchandiseDutyId === dutyId
          ? { ...item, ...updates }
          : item
      ),
      ...additionalState
    }));
  };

  shouldComponentUpdate(nextProps, nextState) {
    if (window.slowstate) return true;
    if (this.state.showhtspopup) return true;

    // Product History updates via prodHistoryFormData (mapStateToProps returns {})
    if (nextProps.prodHistoryFormData !== this.props.prodHistoryFormData) return true;

    if (nextProps.currentMerchandiseDuty !== this.props.currentMerchandiseDuty) return true;
    if (nextProps.merchandiseLineItem !== this.props.merchandiseLineItem) return true;
    if (nextProps.defaultVisible !== this.props.defaultVisible) return true;
    if (nextProps.dutyMetadata !== this.props.dutyMetadata) return true;
    if (nextProps.lineValidObjectsBl !== this.props.lineValidObjectsBl) return true;
    if (nextProps.showLineItem !== this.props.showLineItem) return true;

    if (nextProps.invoiceQuantity !== this.props.invoiceQuantity) return true;
    if (nextProps.invoiceQuantityUnits !== this.props.invoiceQuantityUnits) return true;
    if (nextProps.manifestQuantityQuantity !== this.props.manifestQuantityQuantity) return true;
    if (nextProps.manifestQuantityUnits !== this.props.manifestQuantityUnits) return true;
    if (nextProps.additionalQuantityQuantity !== this.props.additionalQuantityQuantity) return true;
    if (nextProps.additionalQuantityUnits !== this.props.additionalQuantityUnits) return true;

    const formValuesChanged =
      nextProps.newValue !== this.props.newValue ||
      nextProps.fieldName !== this.props.fieldName ||
      nextProps.setINPUTID !== this.props.setINPUTID ||
      nextProps.penClicked !== this.props.penClicked ||
      nextProps.rbCounterID !== this.props.rbCounterID;
    if (formValuesChanged) {
      return formValuesTargetThisMerchandiseLine(this.props, nextProps);
    }

    if (!propsAreEqual_NoRerenderNeeded(this.state, nextState)) return true;

    return false;
  }

  getDutyRate(data) {
    const getUOMs = (dutyComputationCode) => {
      if (dutyComputationCode === 5) {
        return {
          specificUOM: data?.hsDataDtl?.unit2 || data.additionalQuantityUnits,
          otherUOM: data?.hsDataDtl?.unit1 || data.manifestQuantityUnits
        };
      }
      return {
        specificUOM: data?.hsDataDtl?.unit1 || data.manifestQuantityUnits,
        otherUOM: data?.hsDataDtl?.unit2 || data.additionalQuantityUnits
      };
    };

    let dutyRateStr = [];
    const dutyComputationCode = getDutyComputationCode(data?.hsDataDtl);
    const { specificUOM, otherUOM } = getUOMs(dutyComputationCode);

    if (data.specificRate && data.specificRate != 0 && data.specificRate != '_BLANK_' && data.manifestQuantityUnits) {
      dutyRateStr.push(data.specificRate + " cents per " + specificUOM + ", ");
    }
    if (data.otherRate && data.otherRate != 0 && data.otherRate != '_BLANK_' && data.additionalQuantityUnits) {
      dutyRateStr.push(data.otherRate + " cents per " + otherUOM + ", ");
    }
    dutyRateStr.push(data.dutyRate + "%");
    return dutyRateStr.join("");
  }
  // Check field Validity
  validateField(lineItemIndex, fieldName, value) {
    // let warning = 0
    const newState = Object.assign({}, this.state)
    newState.formInfo[fieldName] = value
    this.setState(newState)
    DutyItemFields[fieldName].errors = []
    DutyItemFields[fieldName].valid = true
    if (
      DutyItemFields[fieldName].rules &&
      DutyItemFields[fieldName].rules.length > 0
    ) {
      DutyItemFields[fieldName].rules.forEach(rule => {
        if (!rule.test(value)) {
          DutyItemFields[fieldName].errors.push(rule.message)
          DutyItemFields[fieldName].valid = false
        }
      })
    }

    if (DutyItemFields[fieldName].errors.length) {
      this.addErrorClass(lineItemIndex + fieldName, DutyItemFields)
    } else {
      this.removeErrorClass(lineItemIndex + fieldName, DutyItemFields)
    }
  }
  addErrorClass(fieldName, fieldType) {
    const inputField = document.getElementById(fieldName + window.shipmentId)
    if (inputField) {
      inputField.classList.add('errorInput')
    }
  }

  removeErrorClass(fieldName, fieldType) {
    try {
      const inputField = document.getElementById(fieldName + window.shipmentId)
      if (inputField) {
        inputField.classList.remove('errorInput')
      }
    } catch (e) {
      console.error(e)
    }
  }



  deleteOldPGACVDData(newHts, deletePGAData, hsDataDtlParameter) {
    let {
      merchandiseId,
      shipmentId,
      merchandiseDutyId,
      updateMerchLineItemPgaObject,
      updateMerchLineItemFeild,
      isCommodityDuty,
      adcvd,
      lineItemIndex,
      index,
      updateMerchDutyItemFeild,
      pgaFlagInfos,
      invoiceItemIndex,
      showFrightData,
      invoiceId,
      htsus,
      htsDescription
    } = this.props
    // this.setState({
    //   hts: newHts
    // })

    let programsToSaveIfTheyreThere = [];
    let currentPrograms = get(hsDataDtlParameter, "pgaMetadata.tarriffPgaDetails");
    for (let oneProg of currentPrograms || []) {
      for (let oneDetail of oneProg?.programDetails || []) {
        programsToSaveIfTheyreThere.push(oneDetail.formType);
      }
    }
    let keepx = [];
    let deletex = [];
    let seenx = {};
    for (let oneflag of pgaFlagInfos) {
      let added = false;
      for (let programToKeep of programsToSaveIfTheyreThere) {
        if (seenx[programToKeep]) continue;
        if ((oneflag.pgaType || oneflag.formType) == programToKeep) {
          keepx.push(oneflag);
          added = true;
        }
      }
      if (!added) {
        deletex.push(oneflag);
      }
    }

    if (deletePGAData) {
      deleteUnusedPGAS(keepx, deletex, merchandiseId, shipmentId, lineItemIndex, invoiceItemIndex,
        updateMerchLineItemPgaObject, updateMerchLineItemFeild, true)
      // updateMerchLineItemFeild(lineItemIndex, invoiceItemIndex, "selectedFormTypes", keepx.map(a=>a.pgaType))
      // updateMerchLineItemFeild(lineItemIndex, invoiceItemIndex, "pgaFlagInfos", keepx)



      if (isCommodityDuty == 1 && (hasanyvaluesAdcvd(adcvd, "ad") || hasanyvaluesAdcvd(adcvd, "cvd"))) {
        let shipId = this.props.pscData.pscShipmentId || shipmentId;
        deleteAdCvdFormData(merchandiseId, merchandiseDutyId, shipId, invoiceId);
        updateMerchDutyItemFeild(invoiceItemIndex, lineItemIndex, index, 'adcvd', {})
      }
    }

  }

  componentDidMount() {
    let {
      index,
      lineItemIndex,
      isCommodityDuty,
      setHSDTL,
      htsus,
      invoiceItemIndex,
      countryOfOrigin,
      currentMerchandiseDuty,
      itDate,
      entryDate,
      isDisabled,
      isBrokerKnAdmin,
    } = this.props
    if (!htsus) {
      htsus = this.props.hts || "";
    }
    
    // Check dutyMetadata for error codes on mount
    const errorCode = get(this.props.dutyMetadata, 'data.eventMessage.header.code');
    if (errorCode === 400 || errorCode === 404) {
      this.sethtsError(errorCode);
    }
    let createdJustNow = currentMerchandiseDuty && (currentMerchandiseDuty.whenDutyItemCreated + 5000 > Date.now());
    const fireSetHSDTL = () => {
      setHSDTL(
        itDate,
        {
          mustBeEditable: true,
          isBrokerKnAdmin: this.props.isBrokerKnAdmin,
          dutyIsEditable: this.props.launchFrom !== "PRODUCT_HISTORY" && !isDisabled("dutyItem"),
          ...this.props.EntryTypeInfo, useAggregated: this.props?.useAggregated, fromComponentDidMount: true
        },
        htsus,
        invoiceItemIndex,
        lineItemIndex,
        index,
        isCommodityDuty,
        !createdJustNow,
        this.props.invoiceId,
        this.props.merchandiseId,
        countryOfOrigin,
        this.props.merchandiseLineItem,
        () => { },
        undefined,
        this.props.dutyMetadata
      );
    }
    if (this.props?.defaultVisible || !isLineItemIoLazyLoadEnabled()) {
      this.dutyContentLoaded = true;
      this.setState({ visible: true });
      fireSetHSDTL();
    } else {
      // Lazy load once; keep visible after first load (do not hide on scroll away)
      this.observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            if (!this.state.visible) {
              this.setState({ visible: true });
            }
            if (this.dutyContentLoaded) {
              return;
            }
            if (this.props.launchFrom !== 'PRODUCT_HISTORY') {
              if (this.visibilityTimer) {
                return;
              }
              this.visibilityTimer = setTimeout(() => {
                fireSetHSDTL();
                this.dutyContentLoaded = true;
                this.visibilityTimer = null;
                if (this.observer) {
                  this.observer.disconnect();
                  this.observer = null;
                }
              }, 300);
            } else {
              this.dutyContentLoaded = true;
              if (this.observer) {
                this.observer.disconnect();
                this.observer = null;
              }
            }
          } else if (!this.dutyContentLoaded) {
            this.setState({ visible: false });
            clearTimeout(this.visibilityTimer);
            this.visibilityTimer = null;
          }
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.1,
        }
      );

      if (this.containerRef.current) {
        if (this?.observer?.observe) {
          this.observer.observe(this.containerRef.current);
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.defaultVisible && this.props.defaultVisible) {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      clearTimeout(this.visibilityTimer);
      this.visibilityTimer = null;
      if (!this.state.visible) {
        this.setState({ visible: true });
      }
    }
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
    clearTimeout(this.visibilityTimer);
  }
  deleteHtsStatus = () => {
    this.setState({
      isDeletingHTS: false
    })
  }

  sethtsError = (val) => {
    this.setState({ "htsError": val })
  }

  displayInvalidHtsError = (value) => {
    this.findhts(value);
  };

  getValidationBasedOnHts = (uom, qty, label) => {
    ;
    let netQtyOrCbpQtyFieldVisible = false;
    (this.props.dutyItems || []).forEach((item, index) => {
      if (!index) return;
      if (showNetQtyOrCbpQty1(item?.htsus)) {
        netQtyOrCbpQtyFieldVisible = true;
      }
    });
    const baseHts = this.props.merchandiseLineItem?.merchandiseDuties?.[0]?.htsus?.slice(0, 2)
    const isBaseUnder98 = parseInt(baseHts) < 98 && parseInt(baseHts) > 0;
    // CBP QTY 2: when UOM is JWL, quantity may be 0 or blank and is not required
    const isJwlCbpQty2 =
      label === "ADD NET QTY" &&
      String(uom || "").toUpperCase() === "JWL";
    let error = [];
    if (
      !isJwlCbpQty2 &&
      ((uom !== "_BLANK_" && typeof uom !== "undefined") && (qty === "0.00" || !qty)) &&
      !(isBaseUnder98 && netQtyOrCbpQtyFieldVisible)
    ) {
      error.push(`${label} is required, when unit of measurement is present`)
    } else if ((!uom || uom === "_BLANK_" || typeof uom === "undefined") && qty > 0) {
      // error.push(`unit of measurement is required, when ${label} is present`)
    }

    return error

  }

  findhts = async (value) => {
    let hts = formatHTS(value);
    let countryOfOrigin = this.props.countryOfOrigin
    const sameHts = hts && this.props.htsus && formatHTS(this.props.htsus) === hts;
    const preloadedMetadata = sameHts ? this.props.dutyMetadata : undefined;
    const response = await getHSDtlList(this.props.itDate, this.props.EntryTypeInfo, hts, countryOfOrigin, preloadedMetadata, this.props.merchandiseDutyId);
    if (
      response.data.eventMessage.header &&
      response.data.eventMessage.header.code
    ) {
      this.sethtsError(response.data.eventMessage.header.code);
    } else {
      this.sethtsError(200);
    }
  };
  hidehtspopup = () => {
    this.setState({ showhtspopup: false })
  };

  getAsOfDate = () => {
    let entryTypeInfoObjx = this.props.EntryTypeInfo || {};
    if (entryTypeInfoObjx.entryType === "02" || entryTypeInfoObjx.entryType === "12") {
      if (entryTypeInfoObjx.entryDate && entryTypeInfoObjx.entryDate.epochs) {
        return entryTypeInfoObjx.entryDate.epochs
      }
      else {
        return Date.now()
      }
    }
    else {
      return this.props.itDate ||
        entryTypeInfoObjx?.releaseDate?.epochs ||
        entryTypeInfoObjx?.entryDate?.epochs ||
        Date.now()

    }
  }

  handleInvoiceQuantityBlur = async (payload, callback) => {
    const isTarget = isTargetApp();
    if(isTarget){
      await this.handleInvoiceQuantityBlurTarget(payload, callback);
    }else{
      await this.handleInvoiceQuantityBlurEngine(payload, callback);
    }
    if (this.props.launchFrom !== 'PRODUCT_HISTORY') {
      this.props.invalidateTotals();
    }
  }

  handleInvoiceQuantityBlurTarget  = async ({
    lineItemIndex,
    invoiceItemIndex,
    index,
    invoiceQuantity,
    invoiceQuantityUnits,
    manifestQuantityUnits,
    additionalQuantityUnits,
    hasCbpQty2,
  },callback) => {
    const unit1 = this.props?.hsDataDtlForThisDuty?.unit1
    const unit2 = this.props?.hsDataDtlForThisDuty?.unit2
    // Conversion now applies to all flows (not Target-only)
      // Construct payload for quantity conversion request
      const qtyConversion = [{ targetUOM: unit1, quantityType: "CBP_REPORTING_QUANTITY_1" }]
      if(hasCbpQty2){
        qtyConversion.push({ targetUOM: unit2, quantityType: "CBP_REPORTING_QUANTITY_2" })
      }
      const conversionPayload = {
        eventMessage: {
          conversionRequestData: [
            {
              key: this.props.merchandiseId,
              value: {
                productTag: this.props.productTag,
                htsCode: this.props.htsus,
                sourceUOM: invoiceQuantityUnits,
                invoiceQty: invoiceQuantity,
                qtyConversion
              },
            },
          ],
          customerCode: this.props?.EntryTypeInfo?.customerCode,
        },
        eventType: "QTY_AND_VALUE_CONVERSION",
        eventTime: Date.now(),
      };
    
      const response = await HttpPostRequest(conversionPayload);
      const success = response?.data?.eventMessage?.success === "true";
    
      if (success) {
        const conversionData = response?.data?.eventMessage?.conversionRequestData?.[this.props.merchandiseId]?.qtyConversion;
        const [cbpQty1, cbpQty2] = conversionData?.map(item => item?.cbpQty) || [null, null];
        const updateQtyArr = [];

        updateQtyArr.push(["manifestQuantity", (cbpQty1 || invoiceQuantity)]);
        if(hasCbpQty2)
          updateQtyArr.push(["additionalQuantity", (cbpQty2 || invoiceQuantity)]);
        
          // Update converted quantities
          updateQtyArr.forEach(([key, value]) => {
            this.props.updateMerchDutyItemObject(lineItemIndex, invoiceItemIndex, index, key, "quantity", value);
          });
    
        // Save entry summary duties
        await HttpPostRequest({
          eventType: "SAVE_ENTRY_SUMMARY_DUTIES",
          eventTime: Date.now(),
          eventMessage: {
            descriptionOfMerchandise: {
              entrySummaryInvoices: [
                {
                  invoiceId: this.props.invoiceId,
                  merchandiseLineItems: [
                    {
                      merchandiseId: this.props.merchandiseId,
                      merchandiseDuties: [
                        {
                          invoiceQuantity: { quantity: invoiceQuantity, units: invoiceQuantityUnits},
                          manifestQuantity: { quantity: cbpQty1 },
                          additionalQuantity: { quantity: hasCbpQty2 ? cbpQty2 : " " },
                          merchandiseDutyId: this.props.merchandiseDutyId,
                          isCommodityDuty: this.props?.isCommodityDuty,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            shipmentId: this.props.shipmentId,
          },
        });
      }
    // Update and save invoice quantity
    const formattedInvoiceQty = parseFloat(invoiceQuantity || 0).toFixed(2);
    this.props.updateMerchDutyItemObject(lineItemIndex, invoiceItemIndex, index, "invoiceQuantity", "quantity", formattedInvoiceQty);
    // Sync GROSS/ENTERED VALUE local state with saved values so they refresh without needing a click
    this.props.saveMerchDutyItem(lineItemIndex, invoiceItemIndex, index, "invoiceQuantity", "", "", (values) => {
      this.setState({
        grossValueLocal: values?.invoiceCurrencyValue,
        grossValueLocalFocused: true,
        enteredValueThisFocusedValue: values?.enteredValue,
        enteredValueThisFocused: true
      });
      triggerFormValidationSoon();
      callback && callback();
    });
  };

  handleInvoiceQuantityBlurEngine = async ({
    lineItemIndex,
    invoiceItemIndex,
    index,
    invoiceQuantity,
    invoiceQuantityUnits,
    manifestQuantityUnits,
    additionalQuantityUnits,
    hasCbpQty2,
  }, callback) => {
    const unit1 = this.props?.hsDataDtlForThisDuty?.unit1
    const unit2 = this.props?.hsDataDtlForThisDuty?.unit2
    // Conversion now applies to all flows (not Target-only)
      // Construct payload for quantity conversion request
      const qtyConversion = [{ targetUOM: unit1, quantityType: "CBP_REPORTING_QUANTITY_1" }]
      if (hasCbpQty2) {
        qtyConversion.push({ targetUOM: unit2, quantityType: "CBP_REPORTING_QUANTITY_2" })
      }
      const conversionPayload = {
        eventMessage: {
          conversionRequestData: [
            {
              key: this.props.merchandiseId,
              value: {
                productTag: this.props.productTag,
                htsCode: this.props.htsus,
                sourceUOM: invoiceQuantityUnits,
                invoiceQty: invoiceQuantity,
                qtyConversion
              },
            },
          ],
          customerCode: this.props?.EntryTypeInfo?.customerCode,
        },
        eventType: "QTY_AND_VALUE_CONVERSION",
        eventTime: Date.now(),
      };

      const response = await HttpPostRequest(conversionPayload);
      const success = response?.data?.eventMessage?.success === "true";

      if (success) {
        const conversionData = response?.data?.eventMessage?.conversionRequestData?.[this.props.merchandiseId]?.qtyConversion;
        const [cbpQty1, cbpQty2] = conversionData?.map(item => item?.cbpQty) || [null, null];
        const updateQtyArr = [];

        const conversionRate1 = conversionData?.[0]?.conversionRate;
        
        if(cbpQty1){
          updateQtyArr.push(["manifestQuantity", (cbpQty1 || invoiceQuantity)]);
        }
        if(cbpQty2){
          updateQtyArr.push(["additionalQuantity", (cbpQty2 || invoiceQuantity)]);
        }
          // Update converted quantities
          updateQtyArr.forEach(([key, value]) => {
            this.props.updateMerchDutyItemObject(lineItemIndex, invoiceItemIndex, index, key, "quantity", value);
          });
    
        // Save entry summary duties
        await HttpPostRequest({
          eventType: "SAVE_ENTRY_SUMMARY_DUTIES",
          eventTime: Date.now(),
          eventMessage: {
            descriptionOfMerchandise: {
              entrySummaryInvoices: [
                {
                  invoiceId: this.props.invoiceId,
                  merchandiseLineItems: [
                    {
                      merchandiseId: this.props.merchandiseId,
                      merchandiseDuties: [
                        {
                          invoiceQuantity: { quantity: invoiceQuantity, units: invoiceQuantityUnits},
                          manifestQuantity: { quantity: cbpQty1 ? cbpQty1 : undefined },
                          additionalQuantity: { quantity: cbpQty2 ? cbpQty2 : undefined },
                          merchandiseDutyId: this.props.merchandiseDutyId,
                          isCommodityDuty: this.props?.isCommodityDuty,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            shipmentId: this.props.shipmentId,
          },
        });
      }
    // Update and save invoice quantity
    const formattedInvoiceQty = parseFloat(invoiceQuantity || 0).toFixed(2);
    this.props.updateMerchDutyItemObject(lineItemIndex, invoiceItemIndex, index, "invoiceQuantity", "quantity", formattedInvoiceQty);
    this.props.saveMerchDutyItem(lineItemIndex, invoiceItemIndex, index, "invoiceQuantity", "", "", (values) => {
      this.setState({
        grossValueLocal: values.invoiceCurrencyValue,
        grossValueLocalFocused: true,
        enteredValueThisFocusedValue: values.enteredValue,
        enteredValueThisFocused: true
      });
      triggerFormValidationSoon();
      callback && callback();
    });
  };

  handleInvoiceQuantityUnitBlur = async ({
    lineItemIndex,
    invoiceItemIndex,
    index,
    invoiceQuantity,
    invoiceQuantityUnits,
    value,
    manifestQuantityUnits,
    additionalQuantityUnits,
    hasCbpQty2
  }) => {
    if (this.props.launchFrom === 'PRODUCT_HISTORY') {
      invoiceQuantity.units = value;
      this.props.updateFormState("invoiceQuantity.units", invoiceQuantity, "merchandiseDuties.duties", index)
      return;
    }

    // Conversion now applies to all flows (not Target-only)
      // Construct payload for quantity conversion request
      const qtyConversion = [{ targetUOM: manifestQuantityUnits, quantityType: "CBP_REPORTING_QUANTITY_1" }]
      if (hasCbpQty2) {
        qtyConversion.push({ targetUOM: additionalQuantityUnits, quantityType: "CBP_REPORTING_QUANTITY_2" })
      }
      const conversionPayload = {
        eventMessage: {
          conversionRequestData: [
            {
              key: this.props.merchandiseId,
              value: {
                productTag: this.props.productTag,
                htsCode: this.props.htsus,
                sourceUOM: value,
                invoiceQty: invoiceQuantity,
                qtyConversion
              },
            },
          ],
          customerCode: this.props?.EntryTypeInfo?.customerCode,
        },
        eventType: "QTY_AND_VALUE_CONVERSION",
        eventTime: Date.now(),
      };

      const response = await HttpPostRequest(conversionPayload);
      const success = response?.data?.eventMessage?.success === "true";

      if (success) {
        const conversionData = response?.data?.eventMessage?.conversionRequestData?.[this.props.merchandiseId]?.qtyConversion;
        const [cbpQty1, cbpQty2] = conversionData?.map(item => item?.cbpQty) || [null, null];
        const updateQtyArr = [];

        if (cbpQty1) updateQtyArr.push(["manifestQuantity", cbpQty1]);
        if (cbpQty2) updateQtyArr.push(["additionalQuantity", cbpQty2]);

        // Update converted quantities
        updateQtyArr.forEach(([key, value]) => {
          this.props.updateMerchDutyItemObject(lineItemIndex, invoiceItemIndex, index, key, "quantity", value);
        });

        // Save entry summary duties
        await HttpPostRequest({
          eventType: "SAVE_ENTRY_SUMMARY_DUTIES",
          eventTime: Date.now(),
          eventMessage: {
            descriptionOfMerchandise: {
              entrySummaryInvoices: [
                {
                  invoiceId: this.props.invoiceId,
                  merchandiseLineItems: [
                    {
                      merchandiseId: this.props.merchandiseId,
                      merchandiseDuties: [
                        {
                          invoiceQuantity: { quantity: invoiceQuantity, units: value },
                          manifestQuantity: { quantity: cbpQty1 },
                          additionalQuantity: { quantity: hasCbpQty2 ? cbpQty2 : " " },
                          merchandiseDutyId: this.props.merchandiseDutyId,
                          isCommodityDuty: this.props?.isCommodityDuty,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            shipmentId: this.props.shipmentId,
          },
        });
      }
    this.props.updateMerchDutyItemObject(
      lineItemIndex,
      invoiceItemIndex,
      index,
      "invoiceQuantity",
      "units",
      value
    );
    document.getElementById("VALIDATE_FORM_BUTTON") &&
      document.getElementById("VALIDATE_FORM_BUTTON").click();
  }


  onHtsBlur = async (value, params) => {
    if (value) value = value.trim();

    const { invoiceItemIndex, lineItemIndex, index, isCommodityDuty, updateMerchDutyItemFeild, saveDescriptionOfMerchandiseLine } = this.props;
    const { changeHTSValue, updateHTS, initializeSteelCast, initializeAluminiumCast, initializeCopperCast } = params
    const isCommodityDutyBoolean = isCommodityDuty === 1;

    if (this.props.launchFrom !== 'PRODUCT_HISTORY') {
      // Persist before any await so on-change validate / tree-select blur see the new HTS
      updateMerchDutyItemFeild(
        invoiceItemIndex,
        lineItemIndex,
        index,
        "htsus",
        value
      );
      // Clear stale "not found" until findhts confirms (tree leaf is already a valid code)
      const digits = (value || "").replace(/\./g, "");
      if (digits.length === 8 || digits.length === 10) {
        this.sethtsError(200);
      }
      triggerFormValidationSoon();
    }

    // HTS Tree call should still be triggered even if length doesn't meet API call requirements
    if (this.state.localChangeHassOccurred || this.props?.dutyItems?.length === 1) {
      if (isCommodityDutyBoolean) await updateHTS({ htsNo: value, invoiceItemIndex, lineItemIndex, dutyIndex: index })
    }

    if (this.props.launchFrom === 'PRODUCT_HISTORY') {
      return;
    }

    // Skip all API calls except HTS Tree if HTS length doesn't meet requirements (Main HTS: < 10 digits, Additional HTS: not 8 or 10 digits)
    if (value && !shouldMakeHTSAPICall(value, isCommodityDuty)) {
      this.setState({ thisHTSFocused: false, localChangeHassOccurred: false })
      return;
    }

    if (value) {
      // Await so a later stale blur cannot finish its save after a tree leaf pick.
      await changeHTSValue(value, false, isCommodityDutyBoolean && this.state.localChangeHassOccurred)
    }
    if (isCommodityDutyBoolean) {
      let { importerAdditionalDeclarationDetails } = this.props

      let mainExclusionlistfromServer = JSON.parse(JSON.stringify(get(importerAdditionalDeclarationDetails, 'importerAdditionalDeclarationDetail', [])));
      const initialState = JSON.parse(JSON.stringify(get(importerAdditionalDeclarationDetails, 'importerAdditionalDeclarationDetail', [])));
      mainExclusionlistfromServer = initializeSteelCast(value, mainExclusionlistfromServer);
      mainExclusionlistfromServer = initializeAluminiumCast(value, mainExclusionlistfromServer);
      mainExclusionlistfromServer = initializeCopperCast(value, mainExclusionlistfromServer);
      mainExclusionlistfromServer = fillEmptyMetalCountries(mainExclusionlistfromServer, this.props.countryOfOrigin);
      if (!isEqual(mainExclusionlistfromServer, initialState)) {
        this.props.updateMerchLineItemObject(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails', 'importerAdditionalDeclarationDetail', mainExclusionlistfromServer);
        saveDescriptionOfMerchandiseLine(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails', { importerAdditionalDeclarationDetail: mainExclusionlistfromServer })
      }

    }
    this.setState({ thisHTSFocused: false, localChangeHassOccurred: false })
  }



  render() {

    const isTarget = isTargetApp()
    let {
      index,
      lineItemIndex,
      invoiceItem,
      parentHts,
      indexVal,
      htsus,
      itDate,
      entryDate,
      enteredValueZeroIndex,
      currentEnteredValuex,
      allDuties,
      updateMerchDutyItemFeild,
      updateMerchDutyItemObject,
      saveMerchDutyItem,
      merchandiseId,
      merchandiseDutyId,
      manifestQuantityUnits,
      invoiceQuantityUnits,
      manifestQuantityQuantity,
      invoiceQuantity,
      additionalQuantityUnits,
      additionalQuantityQuantity,
      duty,
      dutyRate,
      dutyRateInfo,
      currentMerchandiseDuty,
      dutyOverrideFlag,
      isCommodityDuty,
      unitList,
      newValue,
      fieldName,
      setINPUTID,
      penClicked,
      shipmentId,
      rbCounterID,
      setHSDTL,
      footnote,
      additionalHtsInfo,
      formDisabled,
      htsDescription,
      categoryCode,
      handleDutyItemContextSwitch,
      // updateTotals,
      removeDutyItem,
      updateTotalValueAndGrossWeight,
      isDisabled,
      charges,
      unitPrice,
      lineValidObjectsBl,
      updateMerchLineItemFeild, displayErrorForEnteredValue, displayErrorMsgForEnterValue,
      saveDescriptionOfMerchandiseLine, invoiceItemIndex, showFrightData, adjustedValue,
      adjustedValueZeroIndex,
      articleHeader,
      pscData,
      countryOfOrigin,
      shipmentETA,
      updateLineItemWeightsBasedonTotalValueAndGrossWeight,
      // currencyConvertedValue,
      currencyConversionRate,
      currencyExchangeInfo,
      invoiceCurrencyValue,
      hsDataDtl,
      hsDataDtlForThisDuty,
      saveMerchAdditionDeletion,
      totalAdditions,
      totalDeletions
    } = this.props;
    currencyExchangeInfo = currencyExchangeInfo || {};
    let invoicehasForeignCurrency = currencyExchangeInfo && currencyExchangeInfo?.fromIsoCurrencyCode != "USD";
    let hasForeignCurrency = currencyExchangeInfo && currencyExchangeInfo?.fromIsoCurrencyCode != "USD";
    const isTotalAdditionDeduction = parseFloat(totalAdditions || 0.0) > 0 || parseFloat(totalDeletions || 0.0) > 0
    const deferInputPersist = this.props.launchFrom !== 'PRODUCT_HISTORY';

    let manifestQuantity = { "quantity": "-999", "unit": "KG" }
    let additionalQuantity = { "quantity": "-999", "unit": "KG" }
    if (this.props.launchFrom === 'PRODUCT_HISTORY') {
      lineItemIndex = get(this.props, "prodHistoryFormData.lineItemIndex", 0);
      let duties = get(this.props, "prodHistoryFormData.merchandiseDuties.duties");
      if (duties) {
        htsus = duties[index].htsus;
        if (duties[index].manifestQuantity) {
          manifestQuantity.quantity = duties[index].manifestQuantity.quantity
          manifestQuantity.unit = duties[index].manifestQuantity.unit
          manifestQuantityQuantity = manifestQuantity.quantity;
          manifestQuantityUnits = manifestQuantity.unit;
          isCommodityDuty = duties[index].isCommodityDuty;
          additionalQuantity.quantity = duties[index].additionalQuantity.quantity
          additionalQuantity.unit = duties[index].additionalQuantity.unit
          additionalQuantityQuantity = additionalQuantity.quantity;
          additionalQuantityUnits = additionalQuantity.unit;
          charges = duties[index].charges;
          enteredValueZeroIndex = duties[index].enteredValue;
          currentEnteredValuex = duties[index].enteredValue;
          dutyRate = duties[index].dutyRate;
          duty = duties[index].duty;
          unitList = this.props.dropdownValues.unitList;
        }
        categoryCode = duties[index].categoryCode;
        htsDescription = duties[index].htsDescription;
      }
    }
    if (!htsus) {
      htsus = this.props.hts || "";
    }

    let htsChapter = parseInt(htsus?.slice(0, 2))
    let isCommodityDutyBoolean = isCommodityDuty === 1;
    let incorrectHTSForCommodity = isCommodityDutyBoolean && (htsChapter < 1 || htsChapter > 97);
    let incorrectHTSForNonCommodity = !isCommodityDutyBoolean && isCommodityHtsChapter(htsChapter);
    let is9802Hts = htsus.startsWith("9802") && !isCommodityDutyBoolean;
    const showNetQtyOrCbpQty1Field = showNetQtyOrCbpQty1(htsus);
    let isCommodityHTS = isCommodityHtsChapter(htsChapter) || is9802Hts;
    let isNonCommodityDutyWithCommodityHTSChapter = isCommodityHtsChapter(htsChapter) && !isCommodityDutyBoolean;
    let showCommodityValue = isCommodityDutyBoolean || isNonCommodityDutyWithCommodityHTSChapter;
    let shouldShowEnteredValue = ((showFrightData === false || is9802Hts) && !isTotalAdditionDeduction) || hasForeignCurrency;
    let commodityHTSOrPrimaryCommodity = isCommodityHTS || isCommodityDutyBoolean;
    if (!isCommodityDutyBoolean) {//non-commodity duties ignore foreign currency
      hasForeignCurrency = false;
    }
    let hasAnyNinetyEightDuty = false;
    if (allDuties) {
      for (let oneduty of allDuties) {
        if (oneduty && oneduty.htsus) {
          if (oneduty.htsus.slice(0, 2) == "98") hasAnyNinetyEightDuty = true;
          if (oneduty.htsus.slice(0, 4) == "9802") hasAnyNinetyEightDuty = false;
          if ((oneduty.htsus + "").replace(/\./g, "") == "99039008") hasAnyNinetyEightDuty = true;
        }
      }
    }

    const ch82SetHtsesAsDropdown = ch82SetHtses.map(aaa => { return ({ id: aaa, value: aaa, description: aaa }) });
    const ch82SetForm = () => {
      const { allDuties, EntryTypeInfo, countryOfOrigin, itDate, currencyExchangeInfo } = this.props;

      for (let oneLine of (this.state.ch82BuilderHash || [])) {
        if (!oneLine.htsus) continue;
        if (this.state[`metadataGathered${oneLine.htsus.replaceAll(".", "")}`]) continue;
        if (!((oneLine.htsus || "").replaceAll(".", "").length == 8 || (oneLine.htsus || "").replaceAll(".", "").length == 10)) continue;
        getHSDtlList(itDate, EntryTypeInfo, oneLine.htsus, countryOfOrigin, undefined, oneLine.merchandiseDutyId).then(newMetaData => {
          this.setState({ [`metadataGathered${oneLine.htsus.replaceAll(".", "")}`]: newMetaData.data.eventMessage });
        });
      }

      const parentHTSObj = (this.state.ch82BuilderHash || []).find(aaa => aaa.isCommodityDuty == 1);
      let largestDutyRate = -999;
      let childHTSObj = null;
      let sumOfAllChildEnteredValues = 0;
      let rateToUseX = 'column1Rate';
      for (let onepotentialbiggest of (this.state.ch82BuilderHash || []).filter(aaa => aaa.isCommodityDuty != 1)) {
        sumOfAllChildEnteredValues += parseFloat(onepotentialbiggest?.enteredValue || 0);
        if (this.state[`metadataGathered${onepotentialbiggest.htsus.replaceAll(".", "")}`]) {
          const currentRate = parseFloat(this.state[`metadataGathered${onepotentialbiggest.htsus.replaceAll(".", "")}`][rateToUseX] || 0);;
          if (largestDutyRate < currentRate) {
            childHTSObj = onepotentialbiggest;
            largestDutyRate = currentRate;
          }
        }
      }

      return <>
        <Modal
          closeIcon
          open={this.state.ch82modalIsOpen}
          style={{ width: "90vw" }}
          onClose={() => {
            this.setState({
              ch82modalIsOpen: false,
              savingch82ModalData: false,
            });

          }}
          trigger={
            <Button onClick={() => {
              this.setState({
                ch82modalIsOpen: true,
                ch82BuilderHash: allDuties.map(aa => {
                  return {
                    merchandiseDutyId: aa.merchandiseDutyId,
                    isCommodityDuty: aa.isCommodityDuty,
                    htsus: aa.htsus,
                    dutyRate: aa.dutyRate,
                    enteredValue: aa.enteredValue
                  }
                }).filter(aaa => (aaa.htsus || "").indexOf("82") == 0)
              })


            }} style={{ fontWeight: 'bold', marginTop: '5px' }}>Ch.82 Set Reporting Applies. Open Set Builder?</Button>}
        >
          <Modal.Header>CH. 82 Set Builder</Modal.Header>
          <Modal.Content style={{ width: '100%' }}>
            <Modal.Description >

              <Grid padded className="nopadcol blk2" columns="equal" key={index}>
                <Grid.Row className="isCommodityDuty hts-description-row merged hts-row" >
                  <h3>Set Builder</h3>
                </Grid.Row>
                <Grid.Row className="isCommodityDuty hts-description-row merged hts-row" >
                  <Grid.Column className="no-field-margin dashedContainer">
                    Type
                  </Grid.Column>
                  <Grid.Column className="no-field-margin dashedContainer">
                    HTS
                  </Grid.Column>
                  <Grid.Column className="no-field-margin dashedContainer">
                    Duty Rate
                  </Grid.Column>
                  <Grid.Column className="no-field-margin dashedContainer">
                    Entered Value
                  </Grid.Column>
                  <Grid.Column className="no-field-margin dashedContainer" style={{ flexGrow: '6' }}>
                    Description
                  </Grid.Column>
                </Grid.Row>
                {(this.state.ch82BuilderHash || []).map((ch82line, iiixi) => {
                  const myMetaData = this.state[`metadataGathered${(ch82line.htsus || "").replaceAll(".", "")}`];
                  return (
                    <Grid.Row className="isCommodityDuty hts-description-row merged hts-row" key={ch82line.merchandiseDutyId}

                      style={iiixi % 2 == 1 ? { backgroundColor: '#eee' } : {}}
                    >
                      <Grid.Column className="no-field-margin" style={{ paddingTop: '0.6rem', paddingLeft: '2rem' }}>
                        <b>
                          {ch82line.isCommodityDuty == 1 ? "Parent" : <>

                            <Icon
                              className={"hts-trash duty-item"}
                              name="trash alternate outline"
                              color={"red"}
                              disabled={this.state.savingch82ModalData}
                              onClick={() => {
                                this.setState({
                                  ch82BuilderHash: this.state.ch82BuilderHash.filter(aaa =>
                                    aaa.merchandiseDutyId != ch82line.merchandiseDutyId)
                                })
                              }}
                            />Child</>}</b>
                      </Grid.Column>
                      <Grid.Column className="no-field-margin" style={{ padding: '0px' }}>
                        {ch82line.isCommodityDuty === 1 ?
                          <Dropdown
                            options={ch82SetHtsesAsDropdown}
                            text={ch82line.htsus}
                            id={ch82line.merchandiseDutyId + " htssssssssssssssxsss"}
                            lazyLoad={true}
                            selection
                            className="narrow"
                            disabled={this.state.savingch82ModalData}
                            onChange={(event, { value }) => {
                              this.updateCh82BuilderHash(ch82line.merchandiseDutyId, { htsus: value }, { anyChangeHasHappened: true });
                            }}
                          /> :
                          <InputField
                            isLabel={false}
                            type={"text"}
                            className={"field-bg"}
                            label={<></>}
                            id={ch82line.merchandiseDutyId + " htsssssssssssssssss"}
                            labelClassName="name-label es"
                            value={ch82line.htsus}
                            disabled={this.state.savingch82ModalData}
                            onChange={(value) => {
                              const currentItem = this.state.ch82BuilderHash.find(aaa => aaa.merchandiseDutyId == ch82line.merchandiseDutyId);
                              const changeOccurred = currentItem.htsus != value;
                              const updates = { htsus: value };
                              if (changeOccurred) {
                                updates.showhtspopupInch82 = true;
                              }
                              this.updateCh82BuilderHash(ch82line.merchandiseDutyId, updates);
                            }}
                            onBlur={(value) => {
                              const currentItem = this.state.ch82BuilderHash.find(aaa => aaa.merchandiseDutyId == ch82line.merchandiseDutyId);
                              if ((currentItem.htsus || "").length >= 8) {
                                this.updateCh82BuilderHash(ch82line.merchandiseDutyId, { showhtspopupInch82: false }, { anyChangeHasHappened: true });
                              }
                            }}
                            newValue={newValue}
                            fieldName={fieldName}
                            setINPUTID={setINPUTID}
                            penClicked={penClicked}
                            shipmentId={shipmentId}
                            rbCounterID={rbCounterID}
                            clearInput={true}
                          />}
                        {ch82line.showhtspopupInch82 && (
                          <HTSCodePopup
                            shipmentETA={itDate || entryDate}
                            code={ch82line.htsus}
                            mapCode={ch82line.htsus}
                            country={"US"}
                            popupId={`hts-popup-ch82-${ch82line.merchandiseDutyId}`}
                            anchorId={ch82line.merchandiseDutyId + " htsssssssssssssssss"}
                            hidehtspopup={() => {
                              this.updateCh82BuilderHash(ch82line.merchandiseDutyId, { showhtspopupInch82: false });
                            }}
                            callbackwhenChanged={(value) => {
                              this.updateCh82BuilderHash(ch82line.merchandiseDutyId, {
                                htsus: value,
                                showhtspopupInch82: value.length < 6
                              }, { anyChangeHasHappened: true });
                            }}
                          />
                        )}
                      </Grid.Column>
                      <Grid.Column className="no-field-margin" style={{ padding: '0.6rem' }}>
                        &nbsp;{myMetaData && myMetaData[rateToUseX]}%
                      </Grid.Column>
                      <Grid.Column className="no-field-margin" style={{ padding: '0px' }}>

                        <InputField
                          isLabel={false}
                          type={"text"}
                          id={ch82line.merchandiseDutyId + " evvvvvvvvvvvv"}
                          label={<></>}
                          disabled={this.state.savingch82ModalData || ch82line.isCommodityDuty === 1}
                          labelClassName="name-label es"
                          value={ch82line.enteredValue}
                          onChange={(value) => {
                            this.updateCh82BuilderHash(ch82line.merchandiseDutyId, { enteredValue: value }, { anyChangeHasHappened: true });
                          }}
                          newValue={newValue}
                          fieldName={fieldName}
                          setINPUTID={setINPUTID}
                          penClicked={penClicked}
                          shipmentId={shipmentId}
                          rbCounterID={rbCounterID}
                          clearInput={true}
                        />
                      </Grid.Column>
                      <Grid.Column className="no-field-margin" style={{ padding: '0.6rem', whiteSpace: 'nowrap', flexGrow: '6' }}>
                        {myMetaData && myMetaData['displayDescription']}
                      </Grid.Column>
                    </Grid.Row>
                  )
                })}
                <Grid.Row className="isCommodityDuty hts-description-row merged hts-row">

                  <Button primary style={{ margin: '0.5rem' }}
                    disabled={this.state.savingch82ModalData}
                    onClick={() => {
                      this.setState({
                        ch82BuilderHash: [...this.state.ch82BuilderHash,
                        {
                          merchandiseDutyId: Math.random() + Date.now(),
                          isCommodityDuty: 2,
                          htsus: "",
                          dutyRate: 0,
                          enteredValue: 0
                        }
                        ],
                        anyChangeHasHappened: true
                      })
                    }}>+ Add</Button>
                  <div style={{ width: '100%', padding: '2.5rem' }}><hr style={{ width: "100%" }} /></div>
                </Grid.Row>
                <Grid.Row className="isCommodityDuty hts-description-row merged hts-row" >
                  <h3>CBP Reporting</h3>
                </Grid.Row>
                <Grid.Row className="isCommodityDuty hts-description-row merged hts-row" >
                  The rate of duty for this line item is determined by the article in the set (the child HTS) subject to the highest rate of duty. Both Duty Rate and Entered Value will be Reported to CBP at the Child Level.
                </Grid.Row>
                <Grid.Row className="isCommodityDuty hts-description-row merged hts-row" >
                  <Grid.Column className="no-field-margin dashedContainer">
                    Type
                  </Grid.Column>
                  <Grid.Column className="no-field-margin dashedContainer">
                    HTS
                  </Grid.Column>
                  <Grid.Column className="no-field-margin dashedContainer">
                    Duty Rate
                  </Grid.Column>
                  <Grid.Column className="no-field-margin dashedContainer">
                    Entered Value
                  </Grid.Column>
                  <Grid.Column className="no-field-margin dashedContainer" style={{ flexGrow: '6' }}>
                    Description
                  </Grid.Column>
                </Grid.Row>
                {childHTSObj?.htsus &&
                  <Grid.Row className="isCommodityDuty hts-description-row merged hts-row" >
                    <Grid.Column className="no-field-margin">
                      Child
                    </Grid.Column>
                    <Grid.Column className="no-field-margin">
                      {childHTSObj?.htsus}
                    </Grid.Column>
                    <Grid.Column className="no-field-margin">
                      &nbsp;{largestDutyRate}%
                    </Grid.Column>
                    <Grid.Column className="no-field-margin">
                      {sumOfAllChildEnteredValues}
                    </Grid.Column>
                    <Grid.Column className="no-field-margin" style={{ padding: '0.6rem', whiteSpace: 'nowrap', flexGrow: '6' }}>
                      {this.state[`metadataGathered${childHTSObj.htsus?.replaceAll(".", "")}`] &&
                        this.state[`metadataGathered${childHTSObj.htsus?.replaceAll(".", "")}`]['displayDescription']}
                    </Grid.Column>
                  </Grid.Row>
                }

                {parentHTSObj &&
                  <Grid.Row className="isCommodityDuty hts-description-row merged hts-row" style={{ backgroundColor: '#eee' }}>
                    <Grid.Column className="no-field-margin">

                      Parent
                    </Grid.Column>
                    <Grid.Column className="no-field-margin">
                      {parentHTSObj.htsus}
                    </Grid.Column>
                    <Grid.Column className="no-field-margin">
                      &nbsp;0.00%
                    </Grid.Column>
                    <Grid.Column className="no-field-margin">
                      0.00
                    </Grid.Column>
                    <Grid.Column className="no-field-margin" style={{ padding: '0.6rem', whiteSpace: 'nowrap', flexGrow: '6' }}>
                      {this.state[`metadataGathered${parentHTSObj.htsus?.replaceAll(".", "")}`] &&
                        this.state[`metadataGathered${parentHTSObj.htsus?.replaceAll(".", "")}`]['displayDescription']}
                    </Grid.Column>
                  </Grid.Row>
                }
              </Grid>
            </Modal.Description>
            <Modal.Actions>
              <Button
                disabled={this.state.savingch82ModalData}
                primary style={{ margin: '0.5rem' }}
                onClick={async () => {
                  if (this.state.anyChangeHasHappened && !window.confirm("Are you sure? Data in the Set Builder will be lost")) return;
                  this.setState({
                    ch82modalIsOpen: false,
                  });

                }}>Cancel</Button>
              <Button
                disabled={!childHTSObj?.htsus || (childHTSObj?.htsus || "").indexOf("82") != 0 || ch82SetHtses.includes((childHTSObj?.htsus || "").replaceAll(".", "")) || !parentHTSObj.htsus || this.state.savingch82ModalData}
                primary style={{ margin: '0.5rem' }}
                onClick={async () => {
                  this.setState({ savingch82ModalData: true });
                  if (this.state.savingch82ModalData) return;
                  if (this.props.enableLineItem ? false : isDisabled("dutyItem")) return;
                  const childIndexX = 0;
                  const parentIndexX = 1
                  const chinaTariffDuty = this.props.allDuties.find(aaa => (aaa.htsus || "").replaceAll(".", "").includes("990388"));
                  if (this.props.allDuties.length < parentIndexX + 1 || this.props.allDuties.indexOf(chinaTariffDuty) == parentIndexX) {
                    //if there's a china tariff at index 1, move it down once
                    createMerchandiseDutyItem(
                      invoiceItemIndex,
                      this.props.invoiceId,
                      merchandiseId,
                      lineItemIndex,
                      this.dutyAddStatus,
                      parentHTSObj?.htsus,
                      get(this.props, 'pscData.pscShipmentId')
                    );
                    await new Promise(r => setTimeout(r, 2500));
                  }
                  changeHTSValueWithIndex(childHTSObj?.htsus, false, true, childIndexX);
                  await new Promise(r => setTimeout(r, 2500));
                  changeHTSValueWithIndex(parentHTSObj?.htsus, false, true, parentIndexX);
                  await new Promise(r => setTimeout(r, 2500));
                  await changeEnteredValueDutyLevel(sumOfAllChildEnteredValues,
                    lineItemIndex,
                    invoiceItemIndex,
                    childIndexX, this.props, allDuties, true)

                  await changeEnteredValueDutyLevel("0.00",
                    lineItemIndex,
                    invoiceItemIndex,
                    parentIndexX, this.props, allDuties, true)

                  updateMerchDutyItemFeild(
                    invoiceItemIndex,
                    lineItemIndex,
                    childIndexX,
                    "invoiceCurrencyValue",
                    (sumOfAllChildEnteredValues / (currencyExchangeInfo?.exchangeRate || 1)).toFixed(2)
                  );
                  await saveMerchDutyItem(
                    lineItemIndex,
                    invoiceItemIndex,
                    childIndexX,
                    "invoiceCurrencyValue",
                    (sumOfAllChildEnteredValues / (currencyExchangeInfo?.exchangeRate || 1)).toFixed(2)
                  );
                  updateMerchDutyItemFeild(
                    invoiceItemIndex,
                    lineItemIndex,
                    parentIndexX,
                    "invoiceCurrencyValue",
                    "0.00"
                  );
                  await saveMerchDutyItem(
                    lineItemIndex,
                    invoiceItemIndex,
                    parentIndexX,
                    "invoiceCurrencyValue",
                    "0.00"
                  );


                  updateMerchDutyItemFeild(
                    invoiceItemIndex,
                    lineItemIndex,
                    parentIndexX,
                    "invoiceCurrencyValue",
                    0
                  );
                  await saveMerchDutyItem(
                    lineItemIndex,
                    invoiceItemIndex,
                    parentIndexX,
                    "invoiceCurrencyValue",
                    0
                  );


                  updateMerchDutyItemFeild(
                    invoiceItemIndex,
                    lineItemIndex,
                    parentIndexX,
                    "charges",
                    0
                  );
                  await saveMerchDutyItem(
                    lineItemIndex,
                    invoiceItemIndex,
                    parentIndexX,
                    "charges",
                    0
                  );


                  updateMerchDutyItemObject(
                    lineItemIndex,
                    invoiceItemIndex,
                    parentIndexX,
                    "manifestQuantity",
                    "units",
                    "PCS"
                  );
                  await saveMerchDutyItem(
                    lineItemIndex,
                    invoiceItemIndex,
                    parentIndexX,
                    "manifestQuantity"
                  );
                  this.props.invalidateTotals();


                  updateMerchDutyItemFeild(
                    invoiceItemIndex,
                    lineItemIndex,
                    childIndexX,
                    "htsus",
                    childHTSObj?.htsus
                  );

                  updateMerchDutyItemFeild(
                    invoiceItemIndex,
                    lineItemIndex,
                    parentIndexX,
                    "htsus",
                    parentHTSObj?.htsus
                  );

                  changeHTSValueWithIndex(childHTSObj?.htsus, false, true, childIndexX);
                  await new Promise(r => setTimeout(r, 3000));
                  changeHTSValueWithIndex(parentHTSObj?.htsus, false, true, parentIndexX);

                  await new Promise(r => setTimeout(r, 3000));

                  this.setState({
                    ch82modalIsOpen: false,
                    savingch82ModalData: false
                  });
                }}>{
                  ch82SetHtses.includes((childHTSObj?.htsus || "").replaceAll(".", "")) ? "Invalid Child HTS" :
                    (childHTSObj?.htsus || "").indexOf("82") != 0 ? "Child must be CH.82" :
                      this.state.savingch82ModalData ? "Saving" : "Save"}</Button>
            </Modal.Actions>
          </Modal.Content>
        </Modal>
      </>
    }

    const overrideDutyRate = (
      invoiceItemIndex,
      lineItemIndex,
      dutyIndex, oneduty) => {
        if (oneduty.dutyOverrideFlag != 1) {
          confirmAlert({
            closeOnClickOutside: false,
            title: `Duty Override: Would you like to override the duty for HTS ${oneduty.htsus}?`,
            buttons: [
              {
                label: <b>Confirm</b>,
                onClick: () => {
                  updateMerchDutyItemFeild(
                    invoiceItemIndex,
                    lineItemIndex,
                    dutyIndex,
                    "dutyOverrideFlag",
                    1
                  );
      
                  saveMerchDutyItem(
                    lineItemIndex,
                    invoiceItemIndex,
                    dutyIndex,
                    ["dutyOverrideFlag", "isCommodityDuty"]
                  );
                  this.props.invalidateTotals();
                }
              },
              {
                label: "Cancel",
                onClick: () => {}
              }
            ]
          });
          return;
        }
      updateMerchDutyItemFeild(
        invoiceItemIndex,
        lineItemIndex,
        dutyIndex,
        "dutyOverrideFlag",
        oneduty.dutyOverrideFlag != 1
          ? 1
          : 2 //1==true
      );
      this.props.invalidateTotals();
      return saveMerchDutyItem(
        lineItemIndex,
        invoiceItemIndex,
        dutyIndex,
        ["dutyOverrideFlag", "isCommodityDuty"]
      );
    }



    const changeHTSValue = async (value, silent, deleteOldPGAs) => {
      return changeHTSValueWithIndex(value, silent, deleteOldPGAs, index)
    }
    const changeHTSValueWithIndex = async (value, silent, deleteOldPGAs, index) => {
      if (this.props.launchFrom === 'PRODUCT_HISTORY') {
        return new Promise((resolve, reject) => { resolve({}); });
      }
      this.displayInvalidHtsError(value);

      //copied to merchandiselineitems HTS #
      if (value && value.indexOf("98") == 0) {
        if ((window[`BOXCHECKRATELIMIT.dutyxClass${merchandiseId}--:not(:checked)`] || 0) + 5000 < Date.now()) {
          let dutyIndex = 0;
          for (let oneduty of this.props.merchandiseLineItem.merchandiseDuties) {

            let overrideDutyLineItem = hasDutyOverride(oneduty, this.props.merchandiseLineItem.merchandiseDuties);

            if (oneduty.dutyOverrideFlag != 1 && overrideDutyLineItem) {
              await overrideDutyRate(
                invoiceItemIndex,
                lineItemIndex,
                dutyIndex, oneduty)
            }
            dutyIndex++;
          }
        }
        window[`BOXCHECKRATELIMIT.dutyxClass${merchandiseId}--:not(:checked)`] = Date.now()
      }
      // let newhtsnoncommodity =
      //   isCommodityDuty === 2 &&
      //   value && value.indexOf("9802") != 0 &&
      //   (value.indexOf("98") == 0 || value.indexOf("99") == 0);
      // if (newhtsnoncommodity && !silent) {
      //   //99/98 chapter reset all this unused stuff// remember this is copied
      //   resetDutyItemFieldsInNonCommodity(
      //     updateMerchDutyItemObject,
      //     lineItemIndex,
      //     invoiceItemIndex,
      //     index,
      //     saveMerchDutyItem,
      //     updateMerchDutyItemFeild
      //   );
      // }

      const responseXYU = await saveMerchDutyItem(
        lineItemIndex,
        invoiceItemIndex,
        index,
        "htsus",
        (value || "").replace(/\./g, "")
      )

      if (shouldMakeHTSAPICall(value, isCommodityDuty)) {
        await setHSDTL(
          itDate,
          { htsHasBeenLengthZero: this.state.htsHasBeenLengthZero, hsDtlCalledFrom: "htsus", parentThis: this, ...this.props.EntryTypeInfo, dutyIsEditable: this.props.launchFrom !== "PRODUCT_HISTORY" && !isDisabled("dutyItem") },
          value,
          invoiceItemIndex,
          lineItemIndex,
          index,
          isCommodityDuty,
          false,
          this.props.invoiceId,
          this.props.merchandiseId,
          countryOfOrigin,
          this.props.merchandiseLineItem,
          (newHSDLData) => {
            for (let oneNewPga of newHSDLData?.pgaMetadata?.tarriffPgaDetails || []) {
              const possiblePrograms = oneNewPga?.programDetails?.map(aaa => aaa.formType);
              if (possiblePrograms.length != 1) continue;
              const alreadyAddedPgas = (this.props.pgaFlagInfos || []).map(aaa => aaa.pgaType);
              if (alreadyAddedPgas.includes(possiblePrograms[0])) continue;
              if (!isWarehouseEntry(this.props.EntryTypeInfo)) {
                this.props.createNewPgaSelection(possiblePrograms[0], false);
              }

            }

            deleteOldPGAs && this.deleteOldPGACVDData(value, true, newHSDLData);

            // Trigger duty override click via parent-controlled method
            if (this.props.onTriggerDutyOverrideClick && this.props.index === 0) {
              this.props.onTriggerDutyOverrideClick(
                index,
                countryOfOrigin,
                newHSDLData.column1Rate,
                dutyOverrideFlag
              );
            }
          }
        );
        handleDutyItemContextSwitch(
          lineItemIndex,
          invoiceItemIndex,
          index
        );
        this.setState({ htsHasBeenLengthZero: false });
      }

      let fieldId = "htsus";
      this.validateField(
        `${lineItemIndex}-${index}-`,
        fieldId,
        value
      );
      // if (isCommodityDuty === 1 && !["NONE"].includes(this.props.merchandiseLineItem.productClaimCode)) {
      //   updateMerchLineItemFeild(
      //     lineItemIndex,
      //     invoiceItemIndex,
      //     "productClaimCode",
      //     "NONE"
      //   );
      //   //&& this.props.merchandiseLineItem.productClaimCode === 'NONE'
      //   saveDescriptionOfMerchandiseLine(
      //     lineItemIndex,
      //     invoiceItemIndex,
      //     "productClaimCode",
      //     "NONE"
      //   );
      // }
      let notRateLimited = (!window.LAST_AUTOUPDATE_global || window.LAST_AUTOUPDATE_global + 2000 < Date.now())
      if (notRateLimited) window.LAST_AUTOUPDATE_global = Date.now();

      let firsthts = index !== 0 && document.getElementsByClassName(merchandiseId + "commodityDuty1")[0];
      firsthts && notRateLimited && firsthts.dispatchEvent(new Event("blur"));


    }


    const meltAndPourDateContext = {
      itDate: this.props.itDate,
      entryDate: this.props.entryDate,
      releaseDate: this.props.releaseDate
    };

    const initializeSteelCast = (hts, mainExclusionlistfromServer) => {
      let { updateMerchLineItemObject, saveDescriptionOfMerchandiseLine } = this.props
      if (!hts) return;
      hts = hts.replaceAll(".", "");
      let updatedList = mainExclusionlistfromServer;
      let existingSteelMeltAndPourObject = updatedList.find(aaa => aaa.steelMeltAndPourCountryDetail?.countryOfMeltAndPour !== "no" && aaa.typeCode == "STEEL_MELT_AND_POUR_COUNTRY_DETAIL");
      // Exempt COO: do not auto-trigger; preserve manually added declaration
      if (isMeltSmeltCastExemptCOO(this.props.countryOfOrigin)) {
        if (existingSteelMeltAndPourObject) {
          updateMerchLineItemObject(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails', 'importerAdditionalDeclarationDetail', updatedList)
          return updatedList;
        }
      }
      const isSteelMeltAndPourHts = !isMeltSmeltCastExemptCOO(this.props.countryOfOrigin) && getSteelMeltAndPourCodes(meltAndPourDateContext).find(xxx => hts.startsWith(xxx));
      if (isSteelMeltAndPourHts) {
        if (!existingSteelMeltAndPourObject || existingSteelMeltAndPourObject.steelMeltAndPourCountryDetail.countryOfMeltAndPour == "no") {
          updatedList = updatedList.filter(aaa => aaa.typeCode != "STEEL_MELT_AND_POUR_COUNTRY_DETAIL");
          updatedList = updatedList.concat({
            typeCode: "STEEL_MELT_AND_POUR_COUNTRY_DETAIL",
            "steelMeltAndPourCountryDetail": {
              "countryOfMeltAndPour": "yes",
              "countryOfMeltAndPourCode": "",
              "countryOfMeltAndPourApplicabilityCode": "no"
            }
          });
        }
      } else {
        if (existingSteelMeltAndPourObject) {
          //FIXME: uncomment if needed steel melt and pour if exists
          // return updatedList;  
          updatedList = updatedList.filter(aaa => aaa.typeCode != "STEEL_MELT_AND_POUR_COUNTRY_DETAIL");
          updatedList = updatedList.concat({
            typeCode: "STEEL_MELT_AND_POUR_COUNTRY_DETAIL",
            "steelMeltAndPourCountryDetail": {
              "countryOfMeltAndPour": "no",
              "countryOfMeltAndPourCode": "",
              "countryOfMeltAndPourApplicabilityCode": "no"
            }
          });
        }
      }

      updateMerchLineItemObject(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails', 'importerAdditionalDeclarationDetail', updatedList)
      return updatedList;
    }

    const initializeAluminiumCast = (hts, mainExclusionlistfromServer) => {
      if (!hts) return;
      hts = hts.replaceAll(".", "");
      const currentUIHTS = this.state.thisHTSFocused ? this.state.thisLocalHtsValue : htsus;
      let { importerAdditionalDeclarationDetails, updateMerchLineItemObject, saveDescriptionOfMerchandiseLine } = this.props
      let existingAluminiumCastObject = mainExclusionlistfromServer.find(aaaa => aaaa.typeCode == "ALUMINUM_SMELT_AND_CAST_COUNTRY_DETAIL");
      // Exempt COO: do not auto-trigger; preserve manually added declaration
      if (isMeltSmeltCastExemptCOO(this.props.countryOfOrigin)) {
        if (existingAluminiumCastObject && !existingAluminiumCastObject?.aluminumSmeltAndCastCountryDetail?.doNotShowAluminum)
          return mainExclusionlistfromServer;
      }
      const targetHTS = Object.values(russiaMetaData).map(a => Object.keys(a)).reduce((a, b) => a.concat(b), []);
      let addAluminiumCast = !isMeltSmeltCastExemptCOO(this.props.countryOfOrigin) && targetHTS.filter(t => hts.startsWith(t)).length > 0;
      // check non-russia codes as well
      if (!addAluminiumCast && !isMeltSmeltCastExemptCOO(this.props.countryOfOrigin)) {
        addAluminiumCast = getAluminumMeltAndPourCodes(meltAndPourDateContext).find(htsCode => hts.startsWith(htsCode)) > 0
      }
      if (addAluminiumCast) {
        if (existingAluminiumCastObject && !existingAluminiumCastObject?.aluminumSmeltAndCastCountryDetail?.doNotShowAluminum)
          return mainExclusionlistfromServer;
      }
      let updatedList = mainExclusionlistfromServer.filter((a) => a.typeCode != "ALUMINUM_SMELT_AND_CAST_COUNTRY_DETAIL")

      updatedList = updatedList.concat({
        typeCode: "ALUMINUM_SMELT_AND_CAST_COUNTRY_DETAIL",
        "aluminumSmeltAndCastCountryDetail": (addAluminiumCast ? {
          "doNotShowAluminum": false,
          "isUsProduct": "no",
          "isPrimaryCountryOfSmeltApplied": "yes",
          "primaryCountryOfSmelt": "",
          "isSecondCountryOfSmeltApplied": "yes",
          "secondaryCountryOfSmelt": "",
          "countryOfCast": ""
        } : {
          "doNotShowAluminum": true,
          "isUsProduct": " ",
          "isPrimaryCountryOfSmeltApplied": "no",
          "primaryCountryOfSmelt": " ",
          "isSecondCountryOfSmeltApplied": "no",
          "secondaryCountryOfSmelt": " ",
          "countryOfCast": " "
        })
      })

      updateMerchLineItemObject(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails', 'importerAdditionalDeclarationDetail', updatedList)
      return updatedList;
    }

    const initializeCopperCast = (hts, mainExclusionlistfromServer) => {
      if (!hts) return mainExclusionlistfromServer;
      hts = hts.replaceAll(".", "");
      let { updateMerchLineItemObject } = this.props
      let existingCopperCastObject = mainExclusionlistfromServer.find(aaaa => aaaa.typeCode == "COPPER_SMELT_AND_CAST_COUNTRY_DETAIL");
      // Exempt COO: do not auto-trigger; preserve manually added declaration
      if (isMeltSmeltCastExemptCOO(this.props.countryOfOrigin)) {
        if (existingCopperCastObject && !existingCopperCastObject?.copperSmeltAndCastCountryDetail?.doNotShowCopper)
          return mainExclusionlistfromServer;
      }
      const addCopperCast = !isMeltSmeltCastExemptCOO(this.props.countryOfOrigin) && getCopperSmeltAndCastCodes().find(htsCode => hts.startsWith(htsCode)) !== undefined;

      if (addCopperCast) {
        if (existingCopperCastObject && !existingCopperCastObject?.copperSmeltAndCastCountryDetail?.doNotShowCopper)
          return mainExclusionlistfromServer;
      }
      let updatedList = mainExclusionlistfromServer.filter((a) => a.typeCode != "COPPER_SMELT_AND_CAST_COUNTRY_DETAIL")

      updatedList = updatedList.concat({
        typeCode: "COPPER_SMELT_AND_CAST_COUNTRY_DETAIL",
        "copperSmeltAndCastCountryDetail": (addCopperCast ? {
          "doNotShowCopper": false,
          "isSecondCountryOfSmeltApplied": "yes",
          "primaryCountryOfSmelt": "",
          "secondaryCountryOfSmelt": "",
          "countryOfMostRecentCast": ""
        } : {
          "doNotShowCopper": true,
          "isSecondCountryOfSmeltApplied": "no",
          "primaryCountryOfSmelt": " ",
          "secondaryCountryOfSmelt": " ",
          "countryOfMostRecentCast": " "
        })
      })

      updateMerchLineItemObject(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails', 'importerAdditionalDeclarationDetail', updatedList)
      return updatedList;
    }

    const exclusionHTSES = getExclusionHTSES(entryDate);


    const commodityDutysHTS = ((allDuties || []).find(duty => duty.isCommodityDuty == 1)?.htsus + "").trim().replaceAll(".", "");
    let OctoberTwelve_TwentyTwentyOne = 1633996800000;
    let hasChinaExclusion = !!(countryOfOrigin === "CN" && entryDate >= OctoberTwelve_TwentyTwentyOne && htsus
      && htsus.startsWith("9903") && exclusionHTSES.includes(commodityDutysHTS) && subExclusionHTSES.includes(htsus));
    const isNinetyNineDuty = htsChapter == "99" && htsus.replace(/\./g, "") != "99039008";
    // let incorrectHts = htsChapter > 9 && (incorrectHTSForNonCommodity || incorrectHTSForCommodity)
    const currentUIHTS = this.state.thisHTSFocused ? this.state.thisLocalHtsValue : htsus;

    // For Chapter 99 with disabled enteredValue, use aggregated Chapter 91 value only if Chapter 91 exists
    const enteredValueFieldX = shouldUseChapter91ForCh99(currentMerchandiseDuty) && hasChapter91Duties(allDuties) && isEnteredValueDisabled(currentMerchandiseDuty)
      ? (() => {
        const ch91Total = getTotalChapter91EnteredValue(allDuties);
        // If ch91Total is 0 (e.g., all Chapter 91 items have adjustedValue = -999), show 0
        // Otherwise, show the rounded total
        return Math.round(ch91Total);
      })()
      : !commodityHTSOrPrimaryCommodity
        ? enteredValueZeroIndex
        : currentEnteredValuex;

    const ch82BehaviorForChargesAndDuties = ch82SetHtses.includes((htsus || "").replaceAll(".", "")) && !isCommodityDutyBoolean;
    let thirdLinePlusBehaviorForCh82 = false;
    if (!!allDuties?.length && allDuties.length >= 3 && ch82SetHtses.includes((allDuties[1].htsus || "").replaceAll(".", "")) && !isCommodityDutyBoolean) {
      if (!(allDuties[2].htsus || "").replaceAll(".", "").startsWith("990388") && index == 2) {
        thirdLinePlusBehaviorForCh82 = true;
      } else if ((allDuties[2].htsus || "").replaceAll(".", "").startsWith("990388") && index == 3) {
        thirdLinePlusBehaviorForCh82 = true;
      }
    }
    return (
      <div ref={this.containerRef} className="duty-item-line">
        {!this.state.visible ? <div>Loading...</div> : <div>
          {thirdLinePlusBehaviorForCh82 &&
            <div style={{ color: 'red' }} className="dashedContainer" >
              CBP Reporting of Ch.82 Sets expects two tariffs: the set header and the set article with highest duty rate. Please delete additional Ch.82 tariffs
            </div>
          }
          <Grid padded className="nopadcol blk2" columns="equal" key={index}>
            <Grid.Row className="isCommodityDuty hts-description-row merged hts-row" style={{ display: 'none' }}></Grid.Row>
            <Grid.Row
              className={(
                isCommodityHTS
                  ? "isCommodityDuty hts-description-row merged hts-row"
                  : "hts-description-row merged hts-row top-margin-prod-hist"
              ) + (isCommodityDutyBoolean ? " iscommoditydutyline " : " ")
              }
            >
              {!isCommodityDutyBoolean &&
                (!this.state.isDeletingHTS ? (
                  <Popup
                    basic
                    content='Remove subduty'
                    // disabled={!hasanyoverrideflag(allDuties)/* disabled = don't show the message */}
                    trigger={
                      <Icon
                        className={!isCommodityDutyBoolean ? "hts-trash duty-item" : ""}
                        name="trash alternate outline"
                        color={"red"}
                        disabled={
                          this.props.enableLineItem ? false : isDisabled("dutyItem")
                        }
                        onClick={() => {
                          confirmAlert({
                            closeOnClickOutside: false,
                            title: `Subduty ${htsus} will be deleted. ${hasanyoverrideflag(allDuties) ? "All duty overrides will be cleared." : ""} Are you sure?`,
                            buttons: [
                              {
                                label: <b>Confirm</b>,
                                onClick: async () => {

                                  if (hasanyoverrideflag(allDuties)) {

                                    let dutyIndex = 0;
                                    for (let onedutyxx of this.props.merchandiseLineItem.merchandiseDuties) {
                                      if (onedutyxx.dutyOverrideFlag == 1) {
                                        await overrideDutyRate(
                                          invoiceItemIndex,
                                          lineItemIndex,
                                          dutyIndex, onedutyxx)
                                      }
                                      dutyIndex++;
                                    }

                                  }
                                  this.setState({
                                    isDeletingHTS: true,
                                  });
                                  removeDutyItem(
                                    merchandiseId,
                                    [merchandiseDutyId],
                                    lineItemIndex,
                                    invoiceItemIndex,
                                    0,//unused
                                    this.deleteHtsStatus,
                                    pscData.pscShipmentId
                                  );
                                  this.props.invalidateTotals();
                                  setTimeout(() => {
                                    let firsthtscode = document.getElementsByClassName(merchandiseId + "commodityDuty1")[0];
                                    let firsthts = index !== 0 && firsthtscode
                                    firsthts && firsthts.dispatchEvent(new Event("blur"));
                                  }, 300)

                                }
                              },
                              {
                                label: `Cancel`,
                                onClick: () => { }
                              }
                            ]
                          })


                        }}
                      />
                    } />
                ) : (<Loader active inline size="mini" className="duty-item-loader" />))}
              <Grid.Column className={"borderStart noBorderRadius"}>
                <UpdateTariffs invoiceId={this.props.invoiceId} merchandiseId={merchandiseId} customConfig={this.props.customConfig}>
                  {({ updateHTS }) => (
                    <>
                      <InputField
                        isLabel={false}
                        id={`${invoiceItemIndex}-${lineItemIndex}-${index}-htsus`}
                        disabled={
                          this.props.launchFrom === "PRODUCT_HISTORY" ? true : (
                            this.props.enableLineItem === true
                              ? false
                              : isDisabled("dutyItem"))
                        }
                        type={"text"}
                        saveOnTabOut={!isCommodityDutyBoolean ? false : true}
                        persistOnBlurOnly={deferInputPersist}
                        onLiveChange={
                          deferInputPersist
                            ? (value) => {
                                this.setState({
                                  thisLocalHtsValue: value,
                                  thisHTSFocused: true,
                                  localChangeHassOccurred: true,
                                  showhtspopup: true,
                                });
                              }
                            : undefined
                        }
                        className={(() => {
                          let className = "field-bg";
                          if (this.props.launchFrom === "PRODUCT_HISTORY" && !isCommodityDutyBoolean)
                            className = "field-bg down-border";
                          if (!isCommodityDutyBoolean) {
                            className += ` right-border ${merchandiseId}commodityDuty2 `;
                          } else {
                            className += ` ${merchandiseId}commodityDuty1 `;

                          }
                          if (
                            htsus?.replace(/\./g, "").length !== 10 &&
                            htsus?.replace(/\./g, "").length !== 8
                          ) {
                            className += " redBgColor";
                          }
                          return className;
                        })()}
                        labelIcon={
                          isCommodityDutyBoolean && footnote !== "NA" && footnote
                            ? getPopUpIcon(
                              "info circle",
                              footnote,
                              "hts-note",
                              merchandiseId,
                              lineItemIndex
                            )
                            : null
                        }
                        label={
                          <>
                            HTS #
                            {htsus !== "" &&
                              ((htsus.replace(/\./g, "").length === 4) ||
                                (htsus.replace(/\./g, "").length === 6) ||
                                (htsus.replace(/\./g, "").length === 8) ||
                                (htsus.replace(/\./g, "").length ===
                                  10)) &&
                              (<React.Fragment><Popup
                                trigger={
                                  <Icon
                                    style={{
                                      paddingLeft: "3px",
                                      position: "relative",
                                      float: "right",
                                      color: "blue",
                                      cursor: "pointer",
                                    }}

                                    name="external alternate"
                                    className="close link icon"
                                    onClick={() => {

                                      window.open(
                                        `https://hts.usitc.gov/?query=${htsus}`,
                                        "_blank"
                                      );


                                    }}
                                  />
                                }

                                content={"Go to Tariff Details"}
                              />
                                <CopyToClipboard text={htsus} />
                                {
                                  (htsus?.replace(/\./g, "").length === 10 ||
                                    htsus?.replace(/\./g, "").length === 8) &&
                                  <QryFuncModal
                                    engineRequest={isShipmentFromEngine()}
                                    // brokerId={window.brokerId}
                                    // brokerGuid={this.props.currentJobData?.brokerGuid}
                                    launchFrom={"MERCHANDISE_LINE"}
                                    hideLeftPanel={true}
                                    dataType={"HTS"}
                                    width={"75%"}
                                    shipId={shipmentId}
                                    hts={htsus}
                                    recentQryCall={false}
                                    baseUrl={window._env_.REACT_APP_BROKER_API_URL}
                                    buttontext={`HTS Query`}
                                    asOfDate={this.getAsOfDate()}
                                  />
                                }
                              </React.Fragment>)}
                          </>
                        }
                        value={currentUIHTS}
                        errors={(() => {
                          let myErrorList = [];
                          // if(incorrectHts){myErrorList.push("HTS code chapter issue:")}
                          // if(incorrectHTSForNonCommodity){myErrorList.push("Invalid HTS code for non commodity (HTS code begining with 98-99 required)")}
                          // if(incorrectHTSForCommodity){myErrorList.push("Invalid HTS code for commodity (HTS code begining with 01-97 required)")}

                          if (
                            htsus?.replace(/\./g, "").length !== 10 &&
                            htsus?.replace(/\./g, "").length !== 8
                          ) {
                            if (this.state.htsError !== 200 && ((window.GLOBAL_SETSTATERATELIMITSAFETY_kvsavk || 0) + 2500 < Date.now())) {
                              window.GLOBAL_SETSTATERATELIMITSAFETY_kvsavk = Date.now();
                              this.setState({ htsError: 200 });
                            }
                            myErrorList.push("HTS code wrong length");
                          } else if (this.state.htsError == 400 || this.state.htsError === 404) {
                            myErrorList.push(" HTS code entered was not found in Database. HTS might not exist for this entry date.");
                          }

                          if (
                            isCommodityDutyBoolean &&
                            indexVal === 0 &&
                            parentHts &&
                            htsus?.replace(/\./g, "") !== parentHts?.replace(/\./g, "")
                          ) {
                            myErrorList.push(
                              "HTS code of first Article:V should be equal to the HTS code of Article:X"
                            );
                          }
                          if (
                            merchandiseDutyId && lineValidObjectsBl[
                            `Merchandiseqwqr${"htsus"}${merchandiseDutyId}`
                            ]
                          ) {
                            myErrorList = myErrorList.concat(
                              lineValidObjectsBl[
                              `Merchandiseqwqr${"htsus"}${merchandiseDutyId}`
                              ]
                            );
                          }

                  return myErrorList;
                })()}
                handleFocus={() => {
                  this.props.handleFocusMID && this.props.handleFocusMID();
                  this.setState({ thisHTSFocused: true })
                  this.setState({ thisLocalHtsValue: currentUIHTS, showhtspopup: true })
                }}
                onChange={(value) => {
                  if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                       return;
                  }
                  this.setState({ thisLocalHtsValue: value, thisHTSFocused: true, localChangeHassOccurred: true })
                  this.setState({ showhtspopup: true });
                }}
                onBlur={async (value, event) => {
                  // Popup open/close is owned by outside-click / Esc / leaf select.
                  // Blur only persists — unless focus moved into the popup itself.
                  const relatedTarget = event?.relatedTarget
                  const popupEl = document.getElementById(
                    `hts-popup-${invoiceItemIndex}-${lineItemIndex}-${index}`
                  )
                  if (relatedTarget && popupEl && popupEl.contains(relatedTarget)) {
                    return
                  }
                  // While the tree is open, ignore blur persists. The focused InputField
                  // (persistOnBlurOnly) often still holds the pre-selection DOM value;
                  // writing that back races leaf selection on additional HTS lines.
                  if (this.state.showhtspopup) {
                    return
                  }
                  if (this.htsTreeSelection != null) {
                    const picked = this.htsTreeSelection
                    this.htsTreeSelection = null
                    const cleaned = (value || '').replace(/\./g, '')
                    if (cleaned !== picked) {
                      this.setState({ thisLocalHtsValue: picked, thisHTSFocused: false })
                      return
                    }
                  }

                          this.onHtsBlur(value, { changeHTSValue, updateHTS, initializeSteelCast, initializeAluminiumCast, initializeCopperCast })
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                      />
                      {this.state.showhtspopup && (
                        <HTSCodePopup
                          topIndex={index}
                          saveMerchDutyItem={saveMerchDutyItem}
                          lineItemIndex={lineItemIndex}
                          getSelectedCode={updateMerchDutyItemFeild}
                          shipmentETA={itDate || entryDate}
                          code={currentUIHTS}
                          mapCode={currentUIHTS}
                          popupId={`hts-popup-${invoiceItemIndex}-${lineItemIndex}-${index}`}
                          anchorId={`${invoiceItemIndex}-${lineItemIndex}-${index}-htsus${shipmentId}`}
                          disabled={
                            this.props.enableLineItem === true
                              ? false
                              : isDisabled("dutyItem")
                          }
                          country={"US"}
                          setHSDTL={(hts) => {
                            updateMerchDutyItemFeild(
                              invoiceItemIndex,
                              lineItemIndex,
                              index,
                              "htsus",
                              hts
                            );
                            if (shouldMakeHTSAPICall(hts, isCommodityDuty)) {
                              saveMerchDutyItem(
                                lineItemIndex,
                                invoiceItemIndex,
                                index,
                                "htsus"
                              );
                              setHSDTL(
                                itDate,
                                { htsHasBeenLengthZero: this.state.htsHasBeenLengthZero, parentThis: this, ...this.props.EntryTypeInfo, dutyIsEditable: this.props.launchFrom !== "PRODUCT_HISTORY" && !isDisabled("dutyItem") },
                                hts,
                                invoiceItemIndex,
                                lineItemIndex,
                                index,
                                isCommodityDuty,
                                false,
                                this.props.invoiceId,
                                merchandiseId,
                                countryOfOrigin,
                                this.props.merchandiseLineItem,
                              );
                              handleDutyItemContextSwitch(
                                lineItemIndex,
                                invoiceItemIndex,
                                index
                              );
                            }
                          }}
                          hidehtspopup={this.hidehtspopup}
                          callbackwhenChanged={async (value, isLeafNode) => {
                            value = (value || "").replace(/\./g, "");
                            if (!isLeafNode) {
                              this.setState({ thisLocalHtsValue: value });
                              return;
                            }
                            // Stamp so a later blur with the stale focused input value cannot
                            // overwrite this leaf selection (intermittent on additional HTS).
                            this.htsTreeSelection = value;
                            this.setState(
                              {
                                thisLocalHtsValue: value,
                                localChangeHassOccurred: true,
                                showhtspopup: false,
                              },
                              async () => {
                                await this.onHtsBlur(value, {
                                  changeHTSValue,
                                  updateHTS,
                                  initializeSteelCast,
                                  initializeAluminiumCast,
                                  initializeCopperCast,
                                });
                                // Drop InputField focus so persistOnBlurOnly stops blocking the
                                // updated prop value from rendering in the field.
                                const anchorEl = document.getElementById(
                                  `${invoiceItemIndex}-${lineItemIndex}-${index}-htsus${shipmentId}`
                                );
                                const inputEl =
                                  anchorEl &&
                                  (anchorEl.tagName === "INPUT"
                                    ? anchorEl
                                    : anchorEl.querySelector && anchorEl.querySelector("input"));
                                if (
                                  inputEl &&
                                  (document.activeElement === inputEl ||
                                    (anchorEl.contains &&
                                      anchorEl.contains(document.activeElement)))
                                ) {
                                  inputEl.blur();
                                }
                              }
                            );
                          }}
                        />
                      )}
                    </>)}
                </UpdateTariffs>
                <Icon
                  style={{
                    color: htsus.replace(/\./g, "").length > 10 ? "#ddd" : "#2185d0",
                    cursor: "pointer",
                    marginTop: "-23px",
                    position: "relative",
                    float: "right",
                    fontSize: "1.3rem"
                  }}
                  name={`sort amount down`}
                  className="hts-dropdown-icon"
                  disabled={htsus.replace(/\./g, "").length > 10 ? true : false}
                  onClick={() => { this.setState({ showhtspopup: true }) }}
                />

              </Grid.Column>
              {!!(isCommodityDutyBoolean && !['-999', ''].includes(categoryCode)) && parseInt(categoryCode) > 0 &&
                <Grid.Column width={2} className="borderEnd hts-description-input noRightBorders  noBorderRadius">
                  <InputField
                    isLabel={false}
                    id={`${lineItemIndex}${index}categoryCode`}
                    errors={
                      merchandiseDutyId?lineValidObjectsBl[
                      `Merchandiseqwqr${"categoryCode"}${merchandiseDutyId}`
                      ]:''
                    }
                    disabled={
                      this.props.launchFrom === "PRODUCT_HISTORY" ? true :
                        (this.props.enableLineItem === true
                          ? false
                          : isDisabled("dutyItem"))
                    }
                    type={"text"}
                    className={(this.props.launchFrom === "PRODUCT_HISTORY" && !isCommodityDutyBoolean) ? "field-bg down-border" : "field-bg"}
                    persistOnBlurOnly={deferInputPersist}
                    label={<>Textile Cat</>}
                    labelClassName="name-label es"
                    value={categoryCode}
                    onChange={(value) => {
                      updateMerchLineItemFeild(
                        lineItemIndex,
                        invoiceItemIndex,
                        'categoryCode',
                        value
                      )
                    }}
                    onBlur={(value) => {
                      if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                        return
                      }
                      saveDescriptionOfMerchandiseLine(
                        lineItemIndex,
                        invoiceItemIndex,
                        'categoryCode'
                      )
                    }}
                    newValue={newValue}
                    fieldName={fieldName}
                    setINPUTID={setINPUTID}
                    penClicked={penClicked}
                    shipmentId={shipmentId}
                    rbCounterID={rbCounterID}
                    clearInput={true}
                  />
                </Grid.Column>
              }

              {/* <span style={{ display: 'none' }}>{!(
                this.props.launchFrom === "PRODUCT_HISTORY" ? true :
                  (this.props.enableLineItem === true
                    ? false
                    : isDisabled("dutyItem"))) && !this.state.htsDescriptionFocusedTrue && hsDataDtlForThisDuty?.displayDescription && !window[merchandiseDutyId + "SAVEDDUTYDESCRIPTION"] && (!htsDescription || !(htsDescription || "").trim()) && <>

                  {(() => {
                    window[merchandiseDutyId + "SAVEDDUTYDESCRIPTION"] = true
                    updateMerchDutyItemFeild(
                      invoiceItemIndex,
                      lineItemIndex,
                      index,
                      "htsDescription",
                      hsDataDtlForThisDuty?.displayDescription
                    );
                    saveMerchDutyItem(
                      lineItemIndex,
                      invoiceItemIndex,
                      index,
                      "htsDescription",
                      hsDataDtlForThisDuty?.displayDescription,
                      hsDataDtlForThisDuty?.priorityNumber
                    );
                  })()}</>}
              </span> */}
              <Grid.Column className="borderEnd hts-description-input  noBorderRadius">
                <InputField
                  isLabel={false}
                  id={`${lineItemIndex}${index}htsDescription`}
                  errors={
                    merchandiseDutyId?lineValidObjectsBl[
                    `Merchandiseqwqr${"htsDescription"}${merchandiseDutyId}`
                    ]:''
                  }
                  disabled={
                    this.props.launchFrom === "PRODUCT_HISTORY" ? true :
                      (this.props.enableLineItem === true
                        ? false
                        : isDisabled("dutyItem"))
                  }
                  type={"text"}
                  className={(this.props.launchFrom === "PRODUCT_HISTORY" && !isCommodityDutyBoolean) ? "field-bg down-border" : "field-bg"}
                  persistOnBlurOnly={deferInputPersist}
                  label={"HTS DESCRIPTION"}
                  labelClassName="name-label es"
                  value={htsDescription}
                  onChange={(value) => {
                    if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                      this.props.updateFormState("htsDescription", value, "merchandiseDuties.duties", index)
                      return;
                    }
                    updateMerchDutyItemFeild(
                      invoiceItemIndex,
                      lineItemIndex,
                      index,
                      "htsDescription",
                      value
                    );
                  }}
                  handleFocus={() => {
                    this.setState({ htsDescriptionFocusedTrue: true })
                    this.props.handleFocusMID && this.props.handleFocusMID();
                    this.setState({ showhtspopup: false }); //hide the popup when we tab from the hts field
                  }}
                  onBlur={(value) => {
                    if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                      return;
                    }
                    saveMerchDutyItem(
                      lineItemIndex,
                      invoiceItemIndex,
                      index,
                      "htsDescription"
                    );
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                  clearInput={true}
                />
              </Grid.Column>
            </Grid.Row>
            {ch82SetHtses.find(ch82grouping => (htsus || "").replaceAll(".", "").startsWith(ch82grouping)) && isCommodityDutyBoolean &&
              !(
                this.props.launchFrom === "PRODUCT_HISTORY" ? true :
                  (this.props.enableLineItem === true
                    ? false
                    : isDisabled("dutyItem")))
              &&
              <>
                <Grid.Row className="merged hts-row last-row prod-hist-display finalRowz ">
                  <Grid.Column
                    style={{ borderTop: isCommodityHTS ? "1px solid gray" : "" }}
                    className="no-field-margin"
                  >
                    {ch82SetForm()}
                  </Grid.Column>
                </Grid.Row>
              </>}
            {((isCommodityDutyBoolean || (isCommodityDutyBoolean && this.props.launchFrom === 'PRODUCT_HISTORY')) &&
              this.props.showLineItem) &&
              this.props.MerchandiseLineItem_co}
            <Grid.Row className="merged hts-row prod-hist-display new-mid-row finalRowz " style={{ marginBottom: "0px important" }}>
              {/*START ENTERED VALUE*/}
              {
                commodityHTSOrPrimaryCommodity
                &&
                <Grid.Column
                  className={
                    articleHeader === "V"
                      ? `borderEnd no-field-margin`
                      : `no-field-margin`
                  }
                >
                  <SelecTextField
                    blockOnBlur={true}
                    disableSearchHeaderSelection={true}
                    commitHighlightOnEnter={true}
                    isLabel={false}
                    dropdownDirectionParam={'center'}
                    divClassName="secColn left-border-bottom"
                    inputName={`${lineItemIndex}${index}invoiceQuantity.weight`}
                    ignoreTabOnInputField={true}
                    disabled={
                      this.props.enableLineItem === true
                        ? false
                        : isDisabled("dutyItem")
                    }
                    selectName="grossWeight.weightUnits"
                    type="text"
                    id={"grossWeight.weightUnits" + merchandiseId + merchandiseDutyId}
                    persistOnBlurOnly={deferInputPersist}
                    label={<React.Fragment>INV QTY
                      {this.state.isINVQtyUpdating && <Loader
                        active
                        inline
                        size="mini"
                        style={{ marginRight: "10px" }}
                      />}</React.Fragment>}
                    width={"16"}
                    textfieldSize={16}
                    className="field-bg"
                    handleFocus={(e) => {
                      e.target.select();
                    }}
                    options={unitList}
                    value={invoiceQuantity}
                    isInteger={true}
                    dropDownValue={invoiceQuantityUnits}
                    updateValue={(value) => {
                      if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                        invoiceQuantity.quantity = value;
                        this.props.updateFormState("invoiceQuantity", invoiceQuantity, "merchandiseDuties.duties", index)
                        return;
                      }
                      updateMerchDutyItemObject(
                        lineItemIndex,
                        invoiceItemIndex,
                        index,
                        "invoiceQuantity",
                        "quantity",
                        value.replace(/[^\d.-]/g, "")
                      );

                    }}
                    updateDropDownValue={(value) => this.handleInvoiceQuantityUnitBlur({
                      lineItemIndex,
                      invoiceItemIndex,
                      index,
                      invoiceQuantity,
                      invoiceQuantityUnits,
                      manifestQuantityUnits,
                      additionalQuantityUnits,
                      value,
                      hasCbpQty2: hsDataDtl?.unit2
                    })}
                    onBlur={(value) => {
                      const blurredQty = coerceBlurQuantity(value, invoiceQuantity);
                      if (parseFloat(blurredQty) === parseFloat(invoiceQuantity)) return;
                      this.setState({ isINVQtyUpdating: true })
                      this.handleInvoiceQuantityBlur({
                        lineItemIndex,
                        invoiceItemIndex,
                        index,
                        invoiceQuantity: blurredQty,
                        invoiceQuantityUnits,
                        manifestQuantityUnits,
                        additionalQuantityUnits,
                        hasCbpQty2: hsDataDtl?.unit2
                      }, () => {
                        this.setState({ isINVQtyUpdating: false })
                      })
                    }
                    }
                    newValue={newValue}
                    fieldName={fieldName}
                    setINPUTID={setINPUTID}
                    penClicked={penClicked}
                    shipmentId={shipmentId}
                    rbCounterID={rbCounterID}
                  />
                </Grid.Column>}
              {/*END ENTERED VALUE*/}
              {/*START Unit price */}
              {(isCommodityDutyBoolean || (isCommodityHTS && !is9802Hts)) && (
                <Grid.Column className="no-field-margin">
                  <InputField
                    subLabelText="$"
                    disabled={
                      this.state.isINVQtyUpdating || ch82BehaviorForChargesAndDuties || (
                        this.props.enableLineItem === true
                          ? false
                          : isDisabled("dutyItem"))
                    }
                    subLabelClass="left-icon"
                    subLabelToFixed={5}
                    id={`${lineItemIndex}-${index}-charges`}
                    type={"text"}
                    className={"field-bg"}
                    persistOnBlurOnly={deferInputPersist}
                    label={<React.Fragment>Unit price
                      {this.state.isUnitPriceUpdating && <Loader
                        active
                        inline
                        size="mini"
                        style={{ marginRight: "10px" }}
                      />}</React.Fragment>}

                    errors={
                      merchandiseDutyId?lineValidObjectsBl[
                      `Merchandiseqwqr${"dutyitemcharges"}${merchandiseDutyId}`
                      ]:''
                    }
                    value={unitPrice}
                    isInteger={true}
                    handleFocus={(e) => {
                      // e.target.select();
                    }}
                    onChange={(value) => {

                      if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                        this.props.updateFormState("unitPrice", value, "merchandiseDuties.duties", index)
                        return;
                      }
                      updateMerchDutyItemFeild(
                        invoiceItemIndex,
                        lineItemIndex,
                        index,
                        "unitPrice",
                        value.replace(/[^\d.-]/g, "")
                      );
                    }}
                    onBlur={(value) => {
                      this.setState({ isUnitPriceUpdating: true })
                      if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                        return;
                      }
                      let newValue = parseFloat(value || 1);
                      const formattedUnitPrice = newValue.toFixed(5);

                      updateMerchDutyItemFeild(
                        invoiceItemIndex,
                        lineItemIndex,
                        index,
                        "unitPrice",
                        formattedUnitPrice
                      );
                      saveMerchDutyItem(
                        lineItemIndex,
                        invoiceItemIndex,
                        index,
                        "unitPrice",
                        formattedUnitPrice,
                        "",
                        (values) => {
                          this.setState({
                            grossValueLocal: values.invoiceCurrencyValue,
                            grossValueLocalFocused: true,
                            enteredValueThisFocusedValue: values.enteredValue,
                            enteredValueThisFocused: true,
                            isUnitPriceUpdating: false
                          }, () => {
                            triggerFormValidationSoon();
                          });
                        }
                      );
                      this.props.invalidateTotals();
                    }}
                    newValue={newValue}
                    fieldName={fieldName}
                    setINPUTID={setINPUTID}
                    penClicked={penClicked}
                    shipmentId={shipmentId}
                    rbCounterID={rbCounterID}
                  />
                  {/* <Warning
                    fieldName={'charges'}
                    merchandiseId={merchandiseId}
                    warningValue={charges}
                  /> */}
                </Grid.Column>
              )}
              {/* Start gross value */}
              {(hasForeignCurrency || isCommodityDutyBoolean || isNonCommodityDutyWithCommodityHTSChapter) &&
                <Grid.Column className="no-field-margin">
                  {/* {commodityHTSOrPrimaryCommodity?} */}
                  <InputField
                    subLabelText={currencyExchangeInfo.fromIsoCurrencyCode}
                    subLabelClass="left-icon"
                    id={`${lineItemIndex}${index}invoiceCurrencyValue`}
                    type={"text"}
                    maxlength={10}
                    className={"field-bg"}
                    label={"GROSS VALUE"}
                    saveOnTabOut={true}
                    persistOnBlurOnly={deferInputPersist}
                    onLiveChange={
                      deferInputPersist
                        ? (value) => {
                            this.setState({ grossValueLocal: value, grossValueLocalFocused: true });
                          }
                        : undefined
                    }
                    errors={
                      merchandiseDutyId?lineValidObjectsBl[
                      `Merchandiseqwqr${"invoiceCurrencyValue"}${merchandiseDutyId}`
                      ]:''
                    }
                    value={this.state.grossValueLocalFocused ? this.state.grossValueLocal : invoiceCurrencyValue}
                    handleFocus={(e) => {
                      this.setState({ grossValueLocal: invoiceCurrencyValue, grossValueLocalFocused: true, grossValueAtFocus: invoiceCurrencyValue })
                      e.target.select();
                    }}
                    disabled={
                      this.state.isINVQtyUpdating || this.state.isUnitPriceUpdating || articleHeader === "X" ||
                      (this.props.enableLineItem === true
                        ? false
                        : !commodityHTSOrPrimaryCommodity || isDisabled("dutyItem"))
                    }
                    onChange={(value) => {
                      updateMerchDutyItemFeild(
                        invoiceItemIndex,
                        lineItemIndex,
                        index,
                        "invoiceCurrencyValue",
                        parseFloat(value || 0).toFixed(2)
                      );
                      if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                        this.props.updateFormState("charges", value, "merchandiseDuties.duties", index)
                      }
                    }}
                    isInteger={true}
                    onBlur={(value) => {
                      const grossValueChanged = parseFloat(value || 0) !== parseFloat(this.state.grossValueAtFocus || 0);
                      // Sync local state with current prop value before resetting focus
                      this.setState({
                        grossValueLocal: this.props.invoiceCurrencyValue,
                        grossValueLocalFocused: false
                      })
                      if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                        return;
                      }
                      // Only perform changes if the field was touched (value was edited)

                      changeEnteredValueDutyLevel(showFrightData ? value * currencyConversionRate : value * currencyConversionRate,
                        lineItemIndex,
                        invoiceItemIndex,
                        index, this.props, allDuties, true, "invoiceCurrencyValue", (value) => {
                          this.setState({ enteredValueThisFocused: true, enteredValueThisFocusedValue: value })
                        })
                      if (grossValueChanged) {
                        this.props.invalidateTotals();
                      }

                    }}
                    newValue={newValue}
                    fieldName={fieldName}
                    setINPUTID={setINPUTID}
                    penClicked={penClicked}
                    shipmentId={shipmentId}
                    rbCounterID={rbCounterID}
                  />
                </Grid.Column>
              }

              {/*START ENTERED VALUE*/}
              {shouldShowEnteredValue && showCommodityValue ? <Grid.Column
                className={
                  articleHeader === "V"
                    ? `borderEnd no-field-margin borderEnd`
                    : `no-field-margin borderEnd`
                }
              >
                <InputField
                  subLabelText="$"
                  subLabelClass="left-icon"
                  id={`${lineItemIndex}${index}enteredValue`}
                  type={"text"}
                  maxlength={10}
                  className={"field-bg"}
                  saveOnTabOut={true}
                  persistOnBlurOnly={deferInputPersist}
                  onLiveChange={
                    deferInputPersist
                      ? (value) => {
                          this.setState({
                            enteredValueThisFocusedValue: value,
                            previousEnteredValue: true,
                            enteredValueThisFocused: true,
                          });
                        }
                      : undefined
                  }
                  label={
                    (showFrightData === false || is9802Hts) && !isTotalAdditionDeduction ? "ENTERED VALUE" :
                      hasForeignCurrency ? "CONVERTED VALUE" :
                        "GROSS VALUE"

                  }
                  errors={
                    (merchandiseDutyId?lineValidObjectsBl[
                    `Merchandiseqwqr${"enteredValue"}${merchandiseDutyId}`
                    ]:'') || displayErrorForEnteredValue
                  }
                  value={this.state.enteredValueThisFocused ? this.state.enteredValueThisFocusedValue :
                    enteredValueFieldX
                  } //98-99 we show the zero index
                  handleFocus={(e) => {
                    this.setState({ enteredValueThisFocused: false, enteredValueThisFocusedValue: enteredValueFieldX })
                    e.target.select();
                  }}
                  disabled={
                    this.state.isINVQtyUpdating || this.state.isUnitPriceUpdating || ch82BehaviorForChargesAndDuties ||
                    !commodityHTSOrPrimaryCommodity ||
                    (hasForeignCurrency && isCommodityDutyBoolean) ||
                    articleHeader === "X" ||
                    (this.props.enableLineItem === true
                      ? false
                      : !commodityHTSOrPrimaryCommodity || isDisabled("dutyItem"))
                  }
                  onChange={(value) => {
                    if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                      this.props.updateFormState("enteredValue", value, "merchandiseDuties.duties", index)
                      return;
                    }
                    if (!showFrightData) value = Math.round(value || 0).toString();
                    displayErrorMsgForEnterValue(
                      lineItemIndex,
                      invoiceItemIndex,
                      index,
                      "enteredValue",
                      [],
                      value
                    );
                    updateMerchDutyItemFeild(
                      invoiceItemIndex,
                      lineItemIndex,
                      index,
                      "enteredValue",
                      value.replace(/[^\d.-]/g, "")
                    );
                    // persistOnBlurOnly + saveOnTabOut fires onChange on every tab-out.
                    // Only reverse-calculate GROSS VALUE when the user actually edited ENTERED VALUE;
                    // otherwise a rounded entered value (45) overwrites a more precise gross (44.67).
                    if (this.state.previousEnteredValue) {
                      updateMerchDutyItemFeild(
                        invoiceItemIndex,
                        lineItemIndex,
                        index,
                        "invoiceCurrencyValue",
                        (parseFloat(value || 0) / (currencyConversionRate || 1)).toFixed(2)
                      );
                    }
                  }}
                  onBlur={(value) => {
                    const hadChange = this.state.previousEnteredValue;
                    this.setState({ previousEnteredValue: false });
                    if (!hadChange) {
                      return;
                    }

                    if (!showFrightData) value = Math.round(value || 0)
                    this.setState({ enteredValueThisFocused: false, enteredValueThisFocusedValue: "No show" })
                    changeEnteredValueDutyLevel(value,
                      lineItemIndex,
                      invoiceItemIndex,
                      index, this.props, allDuties, true, "enteredValue").then((resp) => {

                        saveMerchDutyItem(
                          lineItemIndex,
                          invoiceItemIndex,
                          index,
                          "invoiceCurrencyValue"
                        );
                      });
                    // }
                    this.props.invalidateTotals();

                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
              </Grid.Column> : null}
              {/*END ENTERED VALUE*/}

            </Grid.Row>
            <Grid.Row className={`merged hts-row  prod-hist-display ${isCommodityDutyBoolean ? "" : "last-row finalRowz"}`}>
              {!isCommodityDutyBoolean && hasChinaExclusion && (
                <Grid.Column
                  style={{ borderTop: isCommodityHTS ? "1px solid gray" : "" }}
                  className="no-field-margin"
                >
                  {/*START disclaim china*/}
                  <Checkbox
                    className="name-label es"
                    label={"China exclusion"
                    }
                    disabled={
                      this.props.launchFrom === "PRODUCT_HISTORY" ? true : (
                        this.props.enableLineItem === true
                          ? false
                          : isDisabled("dutyItem"))
                    }
                    checked={chinaExlcusionHTSTriggers(entryDate).map(a => a.replaceAll(".", "")).includes(htsus)}
                    onChange={async (event, value) => {
                      if (!chinaExlcusionHTSTriggers(entryDate).map(a => a.replaceAll(".", "")).includes(htsus)) {
                        let exclusionButtons = [
                          {
                            label: `Cancel`,
                            onClick: () => { }
                          }
                        ];

                        for (let exclusionHTS of chinaExlcusionHTSTriggers(entryDate)) {
                          let noperiodsHTS = exclusionHTS.replaceAll(".", "");
                          exclusionButtons.unshift({
                            label: <b>{exclusionHTS} Exclusion</b>,
                            onClick: () => {
                              localStorage.setItem(`${invoiceItemIndex}-${lineItemIndex}-${index}-htsus`, htsus)
                              updateMerchDutyItemFeild(
                                invoiceItemIndex,
                                lineItemIndex,
                                index,
                                "htsus",
                                noperiodsHTS
                              );

                              changeHTSValue(noperiodsHTS, true, false)


                              updateMerchDutyItemFeild(invoiceItemIndex, lineItemIndex, index, "chinaExclusionFlag", '1');
                              saveMerchDutyItem(lineItemIndex, invoiceItemIndex, index, "chinaExclusionFlag"
                              );

                            }
                          })
                        }
                        confirmAlert({
                          closeOnClickOutside: true,
                          title: `Claim the China exclusion for this line item. `,
                          buttons: exclusionButtons
                        })
                      } else {


                        let nonChinaHTS = localStorage.getItem(`${invoiceItemIndex}-${lineItemIndex}-${index}-htsus`) || "";
                        updateMerchDutyItemFeild(invoiceItemIndex, lineItemIndex, index, "htsus", nonChinaHTS);

                        changeHTSValue(nonChinaHTS, true, false)


                        updateMerchDutyItemFeild(invoiceItemIndex, lineItemIndex, index, "chinaExclusionFlag", '2');
                        saveMerchDutyItem(lineItemIndex, invoiceItemIndex, index, "chinaExclusionFlag");
                      }
                    }}
                    newValue={newValue}
                    fieldName={fieldName}
                    setINPUTID={setINPUTID}
                    penClicked={penClicked}
                    shipmentId={shipmentId}
                    rbCounterID={rbCounterID}
                  />
                  {/*END disclaim china*/}


                </Grid.Column>
              )}

              {/*START ENTERED VALUE*/}
              {shouldShowEnteredValue && !showCommodityValue ? <Grid.Column
                className={
                  articleHeader === "V"
                    ? `borderEnd no-field-margin borderEnd`
                    : `no-field-margin borderEnd`
                }
              >
                <InputField
                  subLabelText="$"
                  subLabelClass="left-icon"
                  id={`${lineItemIndex}${index}enteredValue`}
                  type={"text"}
                  maxlength={10}
                  className={"field-bg"}
                  saveOnTabOut={true}
                  persistOnBlurOnly={deferInputPersist}
                  onLiveChange={
                    deferInputPersist
                      ? (value) => {
                          this.setState({
                            enteredValueThisFocusedValue: value,
                            previousEnteredValue: true,
                            enteredValueThisFocused: true,
                          });
                        }
                      : undefined
                  }
                  label={
                    (showFrightData === false || is9802Hts) && !isTotalAdditionDeduction ? "ENTERED VALUE" :
                      hasForeignCurrency ? "CONVERTED VALUE" :
                        "GROSS VALUE"

                  }
                  errors={
                    (merchandiseDutyId?lineValidObjectsBl[
                    `Merchandiseqwqr${"enteredValue"}${merchandiseDutyId}`
                    ]:'') || displayErrorForEnteredValue
                  }
                  value={this.state.enteredValueThisFocused ? this.state.enteredValueThisFocusedValue :
                    enteredValueFieldX
                  } //98-99 we show the zero index
                  handleFocus={(e) => {
                    this.setState({ enteredValueThisFocused: false, enteredValueThisFocusedValue: enteredValueFieldX })
                    e.target.select();
                  }}
                  disabled={
                    this.state.isINVQtyUpdating || this.state.isUnitPriceUpdating || ch82BehaviorForChargesAndDuties ||
                    !commodityHTSOrPrimaryCommodity ||
                    (hasForeignCurrency && isCommodityDutyBoolean) ||
                    articleHeader === "X" ||
                    (this.props.enableLineItem === true
                      ? false
                      : !commodityHTSOrPrimaryCommodity || isDisabled("dutyItem"))
                  }
                  onChange={(value) => {
                    if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                      this.props.updateFormState("enteredValue", value, "merchandiseDuties.duties", index)
                      return;
                    }
                    if (!showFrightData) value = Math.round(value || 0).toString();
                    displayErrorMsgForEnterValue(
                      lineItemIndex,
                      invoiceItemIndex,
                      index,
                      "enteredValue",
                      [],
                      value
                    );
                    updateMerchDutyItemFeild(
                      invoiceItemIndex,
                      lineItemIndex,
                      index,
                      "enteredValue",
                      value.replace(/[^\d.-]/g, "")
                    );
                    // persistOnBlurOnly + saveOnTabOut fires onChange on every tab-out.
                    // Only reverse-calculate GROSS VALUE when the user actually edited ENTERED VALUE;
                    // otherwise a rounded entered value (45) overwrites a more precise gross (44.67).
                    if (this.state.previousEnteredValue) {
                      updateMerchDutyItemFeild(
                        invoiceItemIndex,
                        lineItemIndex,
                        index,
                        "invoiceCurrencyValue",
                        (parseFloat(value || 0) / (currencyConversionRate || 1)).toFixed(2)
                      );
                    }
                  }}
                  onBlur={(value) => {
                    const hadChange = this.state.previousEnteredValue;
                    this.setState({ previousEnteredValue: false });
                    if (!hadChange) {
                      return;
                    }

                    if (!showFrightData) value = Math.round(value || 0)
                    this.setState({ enteredValueThisFocused: false, enteredValueThisFocusedValue: "No show" })
                    changeEnteredValueDutyLevel(value,
                      lineItemIndex,
                      invoiceItemIndex,
                      index, this.props, allDuties, true, "enteredValue").then((resp) => {

                        saveMerchDutyItem(
                          lineItemIndex,
                          invoiceItemIndex,
                          index,
                          "invoiceCurrencyValue"
                        );
                      });
                    // }
                    this.props.invalidateTotals();

                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
              </Grid.Column> : null}
              {/*END ENTERED VALUE*/}
              {commodityHTSOrPrimaryCommodity && (
                <>
                  <Grid.Column
                    className={
                      !commodityHTSOrPrimaryCommodity
                        ? "hide-element  borderStart"
                        : "borderStart"
                    }
                  >
                    <SelecTextField
                      blockOnBlur={true}
                      disableSearchHeaderSelection={true}
                      commitHighlightOnEnter={true}
                      isLabel={false}
                      dropdownDirectionParam={'center'}
                      divClassName="secColn"
                      inputName={`${lineItemIndex}${index}manifestQuantity.weight`}
                      ignoreTabOnInputField={true}
                      errors={(() => {
                        let myErrorList = [];


                        if (
                          merchandiseDutyId && lineValidObjectsBl[
                          `Merchandiseqwqr${"manifestQuantity"}${merchandiseDutyId}`
                          ]
                        ) {
                          myErrorList = myErrorList.concat(
                            merchandiseDutyId ? lineValidObjectsBl[
                            `Merchandiseqwqr${"manifestQuantity"}${merchandiseDutyId}`
                            ] : []
                          );
                        }
                        if (this.getValidationBasedOnHts(manifestQuantityUnits, manifestQuantityQuantity, "NET QTY-HTS UNIT").length > 0) {
                          myErrorList = myErrorList.concat(
                            this.getValidationBasedOnHts(manifestQuantityUnits, manifestQuantityQuantity, "NET QTY-HTS UNIT")
                          );
                        }

                        return myErrorList;
                      })()}
                      // errors={
                      //   fieldValidation.validObjects_bl[
                      //     `Merchandiseqwqr${"manifestQuantity"}${merchandiseDutyId}`
                      //   ]||this.state.hasAdditionalUOMFValidation
                      // }
                      disabled={
                        this.props.enableLineItem === true
                          ? false
                          : isDisabled("dutyItem")
                      }
                      selectName="grossWeight.weightUnits"
                      type="text"
                      id={"grossWeight.weightUnits" + merchandiseId + merchandiseDutyId}
                      persistOnBlurOnly={deferInputPersist}
                      label={"CBP QTY 1"}
                      width={"16"}
                      textfieldSize={16}
                      className="field-bg"
                      handleFocus={(e) => {
                        e.target.select();
                      }}
                      options={unitList}
                      value={manifestQuantityQuantity}
                      isInteger={true}
                      dropDownValue={manifestQuantityUnits}
                      updateValue={(value) => {
                        if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                          manifestQuantity.quantity = value;
                          this.props.updateFormState("manifestQuantity", manifestQuantity, "merchandiseDuties.duties", index)
                          return;
                        }
                        updateMerchDutyItemObject(
                          lineItemIndex,
                          invoiceItemIndex,
                          index,
                          "manifestQuantity",
                          "quantity",
                          value.replace(/[^\d.-]/g, "")
                        );

                      }}
                      updateDropDownValue={(value) => {
                        if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                          manifestQuantity.units = value;
                          this.props.updateFormState("manifestQuantity.units", manifestQuantity, "merchandiseDuties.duties", index)
                          return;
                        }
                        const expectedUnit1 = hsDataDtl?.unit1;
                        const hasMismatch = shouldAlignUomToExpected({ expected: expectedUnit1, current: value });
                        updateMerchDutyItemObject(
                          lineItemIndex,
                          invoiceItemIndex,
                          index,
                          "manifestQuantity",
                          "units",
                          value
                        );
                        const doSave = () => {
                          saveMerchDutyItem(
                            lineItemIndex,
                            invoiceItemIndex,
                            index,
                            "manifestQuantity"
                          );
                          this.props.invalidateTotals();
                          document.getElementById("VALIDATE_FORM_BUTTON") &&
                            document.getElementById("VALIDATE_FORM_BUTTON").click();
                        };

                        if (!hasMismatch) {
                          doSave();
                          return;
                        }

                        confirmUomMismatch({
                          label: "Net Quantity Units",
                          expected: expectedUnit1,
                          got: value,
                          onKeep: () => {
                            toast.warning(`Keeping '${value || "NONE"}'. HTS expected '${expectedUnit1}'.`);
                            doSave();
                          },
                          onSetExpected: () => {
                            updateMerchDutyItemObject(
                              lineItemIndex,
                              invoiceItemIndex,
                              index,
                              "manifestQuantity",
                              "units",
                              expectedUnit1
                            );
                            toast.warning(`Setting Net Quantity Units to expected HTS unit '${expectedUnit1}' and saving.`);
                            doSave();
                          },
                        });


                      }}
                      onBlur={(value) => {
                        if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                          return;
                        }
                        const formattedQty = parseFloat(
                          coerceBlurQuantity(value, manifestQuantityQuantity) || 0
                        ).toFixed(2);
                        updateMerchDutyItemObject(
                          lineItemIndex,
                          invoiceItemIndex,
                          index,
                          "manifestQuantity",
                          "quantity",
                          formattedQty
                        );

                        saveMerchDutyItem(
                          lineItemIndex,
                          invoiceItemIndex,
                          index,
                          "manifestQuantity"
                        );
                        this.props.invalidateTotals();
                        setTimeout(()=> {
                          triggerFormValidationSoon();
                        },0)
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                    />
                    {/* <Warning
                fieldName={'manifestQuantity'}
                merchandiseId={merchandiseId}
                warningValue={manifestQuantityQuantity}
              /> */}
                  </Grid.Column>
                  {(!isTarget || hsDataDtl?.unit2) && <Grid.Column
                    className={
                      !commodityHTSOrPrimaryCommodity ? "hide-element" : ""
                    }
                  >

                    <SelecTextField
                      blockOnBlur={true}
                      disableSearchHeaderSelection={true}
                      commitHighlightOnEnter={true}
                      disableWasChanged={true}
                      isLabel={false}
                      divClassName="secColn"
                      inputName={`${lineItemIndex}${index}additionalQuantity.quantity`}
                      disabled={
                        this.props.enableLineItem === true
                          ? false
                          : isDisabled("dutyItem")
                      }
                      selectName="grossWeight.weightUnits"
                      type="text"
                      persistOnBlurOnly={deferInputPersist}
                      label={"CBP QTY 2"}
                      dropdownDirectionParam={'center'}
                      id={"additionalQuantity" + merchandiseId + merchandiseDutyId}
                      width="16"
                      textfieldSize={16}
                      className="field-bg"
                      handleFocus={(e) => {
                        e.target.select();
                      }}
                      errors={(() => {
                        let myErrorList = [];
                        if (this.getValidationBasedOnHts(additionalQuantityUnits, additionalQuantityQuantity, "ADD NET QTY").length > 0) {
                          myErrorList = myErrorList.concat(
                            this.getValidationBasedOnHts(additionalQuantityUnits, additionalQuantityQuantity, "ADD NET QTY")
                          );
                        }
                        if (
                          merchandiseDutyId && lineValidObjectsBl[
                          `Merchandiseqwqr${"additionalQuantity"}${merchandiseDutyId}`
                          ]
                        ) {
                          myErrorList = myErrorList.concat(
                            lineValidObjectsBl[
                            `Merchandiseqwqr${"additionalQuantity"}${merchandiseDutyId}`
                            ]
                          );
                        }
                        return myErrorList;
                      })()}
                      options={unitList}
                      isInteger={true}
                      value={additionalQuantityQuantity}
                      dropDownValue={additionalQuantityUnits}
                      updateValue={(value) => {
                        if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                          this.props.updateFormState("additionalQuantity.quantity", value, "merchandiseDuties.duties", index)
                          return;
                        }

                        // Set changed flag to true when user types
                        this.setState({ previousAdditionalQuantity: true });

                        updateMerchDutyItemObject(
                          lineItemIndex,
                          invoiceItemIndex,
                          index,
                          "additionalQuantity",
                          "quantity",
                          value.replace(/[^\d.-]/g, "")
                        );

                      }}
                      updateDropDownValue={(value) => {
                        if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                          this.props.updateFormState("additionalQuantity.units", value, "merchandiseDuties.duties", index)
                          return;
                        }
                        const expectedUnit2 = hsDataDtl?.unit2;
                        const hasMismatch = shouldAlignUomToExpected({ expected: expectedUnit2, current: value });
                        updateMerchDutyItemObject(
                          lineItemIndex,
                          invoiceItemIndex,
                          index,
                          "additionalQuantity",
                          "units",
                          value
                        );
                        const doSave = () => {
                          saveMerchDutyItem(
                            lineItemIndex,
                            invoiceItemIndex,
                            index,
                            "additionalQuantity"
                          );
                          this.props.invalidateTotals();
                          document.getElementById("VALIDATE_FORM_BUTTON") &&
                            document.getElementById("VALIDATE_FORM_BUTTON").click();
                        };

                        if (!hasMismatch) {
                          doSave();
                          return;
                        }

                        confirmUomMismatch({
                          label: "Additional Quantity Units",
                          expected: expectedUnit2,
                          got: value,
                          onKeep: () => {
                            toast.warning(`Keeping '${value || "NONE"}'. HTS expected '${expectedUnit2}'.`);
                            doSave();
                          },
                          onSetExpected: () => {
                            updateMerchDutyItemObject(
                              lineItemIndex,
                              invoiceItemIndex,
                              index,
                              "additionalQuantity",
                              "units",
                              expectedUnit2
                            );
                            toast.warning(`Setting Additional Quantity Units to expected HTS unit '${expectedUnit2}' and saving.`);
                            doSave();
                          },
                        });

                      }}
                      onBlur={(value) => {
                        if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                          return;
                        }

                        const formattedQty = parseFloat(
                          coerceBlurQuantity(value, additionalQuantityQuantity) || 0
                        ).toFixed(2);
                        updateMerchDutyItemObject(
                          lineItemIndex,
                          invoiceItemIndex,
                          index,
                          "additionalQuantity",
                          "quantity",
                          formattedQty
                        );

                        clearTimeout(window.GLOBAL_additionalquantitiytimeout);
                        window.GLOBAL_additionalquantitiytimeout = setTimeout(
                          () => {
                            saveMerchDutyItem(
                              lineItemIndex,
                              invoiceItemIndex,
                              index,
                              "additionalQuantity"
                            );
                            this.props.invalidateTotals();
                          },
                          400
                        );

                        this.setState({ previousAdditionalQuantity: false });
                        setTimeout(()=>{
                          triggerFormValidationSoon(); 
                        },2000);
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                    />
                  </Grid.Column>}
                </>
              )}
              {showNetQtyOrCbpQty1Field &&
                !isCommodityDutyBoolean &&
                <Grid.Column className={"no-field-margin"}>
                  <SelecTextField
                    disableSearchHeaderSelection={true}
                    commitHighlightOnEnter={true}
                    isLabel={false}
                    dropdownDirectionParam={'center'}
                    divClassName="secColn left-border-bottom"
                    inputName={`${lineItemIndex}${index}manifestQuantity.weight`}
                    ignoreTabOnInputField={true}
                    errors={(() => {
                      let myErrorList = [];
                      const fieldMsgs = (merchandiseDutyId? lineValidObjectsBl[
                        `Merchandiseqwqr${"manifestQuantity"}${merchandiseDutyId}`
                      ]:[]) || [];
                      const softWarnMsg = "NET QTY-HTS UNIT is required, when unit of measurement is present";
                      myErrorList = myErrorList.concat(
                        fieldMsgs.filter((msg) => msg !== softWarnMsg)
                      );
                      if (this.getValidationBasedOnHts(manifestQuantityUnits, manifestQuantityQuantity, "NET QTY-HTS UNIT").length > 0) {
                        myErrorList = myErrorList.concat(
                          this.getValidationBasedOnHts(manifestQuantityUnits, manifestQuantityQuantity, "NET QTY-HTS UNIT")
                        );
                      }

                      return myErrorList;
                    })()}
                    warnings={(() => {
                      const fieldMsgs = merchandiseDutyId ? lineValidObjectsBl[
                        `Merchandiseqwqr${"manifestQuantity"}${merchandiseDutyId}`
                      ] : '';
                      const softWarnMsg = "NET QTY-HTS UNIT is required, when unit of measurement is present";
                      return fieldMsgs ? fieldMsgs.filter((msg) => msg === softWarnMsg) : [];
                    })()}
                    // errors={
                    //   fieldValidation.validObjects_bl[
                    //     `Merchandiseqwqr${"manifestQuantity"}${merchandiseDutyId}`
                    //   ]||this.state.hasAdditionalUOMFValidation
                    // }
                    disabled={
                      this.props.enableLineItem === true
                        ? false
                        : isDisabled("dutyItem")
                    }
                    selectName="grossWeight.weightUnits"
                    type="text"
                    id={"grossWeight.weightUnits" + merchandiseId + merchandiseDutyId}
                    persistOnBlurOnly={deferInputPersist}
                    label={"CBP QTY 1"}
                    width={"16"}
                    textfieldSize={16}
                    className="field-bg"
                    handleFocus={(e) => {
                      e.target.select();
                    }}
                    options={unitList}
                    value={manifestQuantityQuantity}
                    isInteger={true}
                    dropDownValue={manifestQuantityUnits}
                    updateValue={(value) => {
                      if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                        manifestQuantity.quantity = value;
                        this.props.updateFormState("manifestQuantity", manifestQuantity, "merchandiseDuties.duties", index)
                        return;
                      }
                      updateMerchDutyItemObject(
                        lineItemIndex,
                        invoiceItemIndex,
                        index,
                        "manifestQuantity",
                        "quantity",
                        value.replace(/[^\d.-]/g, "")
                      );

                    }}
                    updateDropDownValue={(value) => {
                      if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                        manifestQuantity.units = value;
                        this.props.updateFormState("manifestQuantity.units", manifestQuantity, "merchandiseDuties.duties", index)
                        return;
                      }
                      updateMerchDutyItemObject(
                        lineItemIndex,
                        invoiceItemIndex,
                        index,
                        "manifestQuantity",
                        "units",
                        value
                      );
                      document.getElementById("VALIDATE_FORM_BUTTON") &&
                        document.getElementById("VALIDATE_FORM_BUTTON").click();


                    }}
                    onBlur={(value) => {
                      if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                        return;
                      }
                      const formattedQty = parseFloat(
                        coerceBlurQuantity(value, manifestQuantityQuantity) || 0
                      ).toFixed(2);
                      updateMerchDutyItemObject(
                        lineItemIndex,
                        invoiceItemIndex,
                        index,
                        "manifestQuantity",
                        "quantity",
                        formattedQty
                      );

                      saveMerchDutyItem(
                        lineItemIndex,
                        invoiceItemIndex,
                        index,
                        "manifestQuantity"
                      );
                      this.props.invalidateTotals();
                    }}
                    newValue={newValue}
                    fieldName={fieldName}
                    setINPUTID={setINPUTID}
                    penClicked={penClicked}
                    shipmentId={shipmentId}
                    rbCounterID={rbCounterID}
                  />
                </Grid.Column>
              }
              {
                <Grid.Column
                  className={"no-field-margin"}
                  style={
                    (showFrightData === false || is9802Hts) && !isTotalAdditionDeduction
                      ? { display: "none" }
                      : { display: "block" }
                  }
                >
                  <InputField
                    subLabelText="$"
                    subLabelClass="left-icon"
                    id={`${lineItemIndex}${index}adjustedValue`}
                    type={"text"}
                    className={"field-bg"}
                    label={"ENTERED VALUE"}
                    saveOnTabOut={true}
                    errors={
                      merchandiseDutyId?lineValidObjectsBl[
                      `Merchandiseqwqr${"adjustedValue"}${merchandiseDutyId}`
                      ]:''
                    }
                    value={
                      !commodityHTSOrPrimaryCommodity
                        ? adjustedValueZeroIndex === -1 ||
                          adjustedValueZeroIndex === -999
                          ? "0.00"
                          : parseFloat(adjustedValueZeroIndex || 0.0).toFixed(
                            2
                          ) || "0.00"
                        : adjustedValue === -999 ||
                          adjustedValue === -1 ||
                          adjustedValueZeroIndex === -999
                          ? "0.00"
                          : parseFloat(adjustedValue || 0.0).toFixed(2) || "0.00"
                    }
                    handleFocus={(e) => {
                      e.target.select();
                    }}
                    disabled={true}
                    onChange={(value) => {
                      if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                        this.props.updateFormState("charges", value, "merchandiseDuties.duties", index)
                        return;
                      }
                      updateMerchDutyItemFeild(
                        invoiceItemIndex,
                        lineItemIndex,
                        index,
                        "adjustedValue",
                        value.replace(/[^\d.-]/g, "")
                      );
                    }}
                    isInteger={true}
                    onBlur={(value) => {
                      if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                        return;
                      }
                      const formattedAdjusted = Math.round(parseFloat(value || 0)).toFixed(2);
                      updateMerchDutyItemFeild(
                        invoiceItemIndex,
                        lineItemIndex,
                        index,
                        "adjustedValue",
                        formattedAdjusted
                      );
                      saveMerchDutyItem(
                        lineItemIndex,
                        invoiceItemIndex,
                        index,
                        "adjustedValue",
                        formattedAdjusted
                      );
                    }}
                    newValue={newValue}
                    fieldName={fieldName}
                    setINPUTID={setINPUTID}
                    penClicked={penClicked}
                    shipmentId={shipmentId}
                    rbCounterID={rbCounterID}
                  />
                </Grid.Column>
              }
              {articleHeader !== "V" && (
                <>
                  <Grid.Column className={"no-field-margin"}>
                    <InputField
                      subLabelText="%"
                      subLabelClass="right-icon"
                      id={`${lineItemIndex}${index}dutyRate`}
                      //disabled={this.props.enableLineItem === true ? false : isDisabled('dutyItem')}
                      disabled={true}
                      type={"text"}
                      errors={
                        merchandiseDutyId?lineValidObjectsBl[
                        `Merchandiseqwqr${"dutyRate"}${merchandiseDutyId}`
                        ]:''
                      }
                      className={"field-bg " + (this.getDutyRate(this.props) || "").split(" ").join("")}//force rerender on duty rate change
                      label={"DUTY RATE"}
                      value={
                        (ch82BehaviorForChargesAndDuties) ? "0.00" :
                          dutyRate}
                      labelIcon={
                        <PopUpIcon
                          icon="info circle"
                          popupText={this.getDutyRate(this.props)}
                        />
                      }
                      isInteger={true}
                      handleFocus={(e) => {
                        e.target.select();
                      }}
                      onChange={(value) => {
                        updateMerchDutyItemFeild(
                          invoiceItemIndex,
                          lineItemIndex,
                          index,
                          "dutyRate",
                          value.replace(/[^\d.-]/g, "")
                        );
                      }}
                      onBlur={(value) => {
                        // Update value according to decimal format
                        updateMerchDutyItemFeild(
                          invoiceItemIndex,
                          lineItemIndex,
                          index,
                          "dutyRate",
                          parseFloat(value || 0).toFixed(2)
                        );
                        saveMerchDutyItem(
                          lineItemIndex,
                          invoiceItemIndex,
                          index,
                          "dutyRate"
                        );
                        this.props.invalidateTotals();
                        // updateTotals()
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                    />
                  </Grid.Column>
                  {
                    this.props.launchFrom !== 'PRODUCT_HISTORY' &&
                    <Grid.Column className={"borderEnd no-field-margin duty"}>
                      <InputField
                        subLabelText="$"
                        subLabelClass="left-icon"
                        id={`${lineItemIndex}${index}duty`}
                        disabled={
                          this.props.enableLineItem === true
                            ? false
                            : isDisabled("dutyItem")
                        }
                        type={"text"}
                        className={"field-bg"}
                        persistOnBlurOnly={deferInputPersist}
                        errors={
                          merchandiseDutyId?lineValidObjectsBl[
                          `Merchandiseqwqr${"duty"}${merchandiseDutyId}`
                          ]:''
                        }
                        label={
                          <>
                            DUTY &nbsp;
                            <>
                              <input
                                title="OVERRIDE DUTY RATE"
                                className={`dutyxClass${merchandiseId}--dutyoverridecheckbox`}
                                disabled={
                                  this.props.enableLineItem ? false : isDisabled("dutyItem")
                                }
                                type="checkbox"
                                ref={(ref) => {
                                  this.inputRef.current = ref;
                                  // Expose ref to parent when it's set
                                  if (this.props.onDutyOverrideRef && ref) {
                                    this.props.onDutyOverrideRef(index, this.inputRef);
                                  }
                                }}
                                id={`${invoiceItemIndex}${lineItemIndex}${index}dutyOverrideFlag`}
                                onChange={() => {

                                  overrideDutyRate(
                                    invoiceItemIndex,
                                    lineItemIndex,
                                    index, currentMerchandiseDuty)

                                }}
                                checked={
                                  currentMerchandiseDuty.dutyOverrideFlag ==
                                  1 /*1==true*/
                                }
                              />
                              Override...
                            </>
                            {/*end overrideDutyLineItem*/}
                          </>
                        }
                        value={duty}
                        isInteger={true}
                        handleFocus={(e) => {
                          e.target.select();
                        }}
                        onChange={(value) => {
                          updateMerchDutyItemFeild(
                            invoiceItemIndex,
                            lineItemIndex,
                            index,
                            "duty",
                            value.replace(/[^\d.-]/g, "")
                          );
                        }}
                        onBlur={(value) => {
                          const formattedDuty = parseFloat(value || 0).toFixed(2);
                          updateMerchDutyItemFeild(
                            invoiceItemIndex,
                            lineItemIndex,
                            index,
                            "duty",
                            formattedDuty
                          );
                          saveMerchDutyItem(
                            lineItemIndex,
                            invoiceItemIndex,
                            index,
                            "duty",
                            formattedDuty
                          );
                          this.props.invalidateTotals();
                          // updateTotals()
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                      />
                    </Grid.Column>
                  }
                </>
              )}
              {/*START CHARGESSSSS */}
              {(isCommodityDutyBoolean || (isCommodityHTS && !is9802Hts)) && (
                <Grid.Column className="no-field-margin borderEnd">
                  <InputField
                    subLabelText="$"
                    disabled={
                      ch82BehaviorForChargesAndDuties || (
                        this.props.enableLineItem === true
                          ? false
                          : isDisabled("dutyItem"))
                    }
                    subLabelClass="left-icon"
                    id={`${lineItemIndex}-${index}-charges`}
                    labelIcon={
                      <PopUpIcon
                        icon="info circle"
                        popupText={
                          "A minimum of $1 will be enforced for this field due to the EDI requirements set by U.S. Customs and Border Protection."
                        }
                      />
                    }
                    type={"text"}
                    className={"field-bg"}
                    persistOnBlurOnly={deferInputPersist}
                    label={"CHARGES"}
                    errors={
                      merchandiseDutyId?lineValidObjectsBl[
                      `Merchandiseqwqr${"dutyitemcharges"}${merchandiseDutyId}`
                      ]:''
                    }
                    value={charges}
                    isInteger={true}
                    handleFocus={(e) => {
                      e.target.select();
                    }}
                    onChange={(value) => {
                      if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                        this.props.updateFormState("charges", value, "merchandiseDuties.duties", index)
                        return;
                      }
                      updateMerchDutyItemFeild(
                        invoiceItemIndex,
                        lineItemIndex,
                        index,
                        "charges",
                        value.replace(/[^\d.-]/g, "")
                      );
                    }}
                    onBlur={(value) => {
                      if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                        return;
                      }
                      let newValue = parseFloat(value || 1);
                      if (newValue < 1) {
                        newValue = 1;
                      }
                      const formattedCharges = Math.round(newValue).toFixed(2);
                      updateMerchDutyItemFeild(
                        invoiceItemIndex,
                        lineItemIndex,
                        index,
                        "charges",
                        formattedCharges
                      );
                      saveMerchDutyItem(
                        lineItemIndex,
                        invoiceItemIndex,
                        index,
                        "charges",
                        formattedCharges
                      );
                    }}
                    newValue={newValue}
                    fieldName={fieldName}
                    setINPUTID={setINPUTID}
                    penClicked={penClicked}
                    shipmentId={shipmentId}
                    rbCounterID={rbCounterID}
                  />
                  {/* <Warning
                    fieldName={'charges'}
                    merchandiseId={merchandiseId}
                    warningValue={charges}
                  /> */}
                </Grid.Column>
              )}
              {/*END CHARGESSSSS */}
            </Grid.Row>
            {isCommodityDutyBoolean && <AdditionDeductionMechLevel
              newValue={newValue}
              fieldName={fieldName}
              setINPUTID={setINPUTID}
              penClicked={penClicked}
              shipmentId={shipmentId}
              rbCounterID={rbCounterID}
              onSave={saveMerchAdditionDeletion} lineItemIndex={lineItemIndex} invoiceItemIndex={invoiceItemIndex} index={index} onUpdate={updateMerchDutyItemObject} className='last-row noTopBorders' disabled={this.props.enableLineItem === true ? false : isDisabled("dutyItem")} />
            }
          </Grid>

        </div>}
      </div>
    );
  }
}

// Conponents using controlled Inputs are not allowed to have props of type array or object. For optimization purposes,
// prevProps will be shallow compared to props to detemine update (based on cahnges form other input components that may cause update)
// Props of array or object will !== and cause shouldC
// DutyItem.propTypes = {
//   lineItemIndex: PropTypes.number.isRequired,
//   index: PropTypes.number.isRequired,
//   htsus: PropTypes.string.isRequired,
//   htsDescription: PropTypes.string.isRequired,
//   grossWeightWeight: PropTypes.string.isRequired,
//   grossWeightWeightUnits: PropTypes.string.isRequired,
//   enteredValue: PropTypes.string.isRequired,
//   merchandiseId: PropTypes.string.isRequired,
//   merchandiseDutyId: PropTypes.string.isRequired,
//   manifestQuantityQuantity: PropTypes.string.isRequired,
//   manifestQuantityUnits: PropTypes.string.isRequired,
//   additionalQuantityQuantity: PropTypes.string.isRequired,
//   additionalQuantityUnits: PropTypes.string.isRequired,
//   duty: PropTypes.string.isRequired,
//   dutyRate: PropTypes.string.isRequired,
//   isCommodityDuty: PropTypes.number.isRequired,
//   unitList: PropTypes.array.isRequired,
//   // newValue: ,
//   // fieldName: ,
//   // setINPUTID: ,
//   // penClicked: ,
//   // rbCounterID: PropTypes.string.isRequired,
//   shipmentId: PropTypes.string.isRequired,
//   footnote: PropTypes.string.isRequired,
//   // formDisabled: PropTypes.bool.isRequired
// }

const mapStateToProps = (state, props) => {
  if (props.launchFrom === 'PRODUCT_HISTORY') {
    return ({

    })
  }
  const invoice = selectInvoiceByIndex(props.invoiceItemIndex)(state);
  const lineItem = selectMerchandiseLineItemByIndex(props.invoiceItemIndex, props.lineItemIndex)(state);
  const duty = selectMerchandiseDutyByIndex(props.invoiceItemIndex, props.lineItemIndex, props.index)(state);


  return ({
    invoiceItemIndex: props.invoiceItemIndex,
    lineItemIndex: props.lineItemIndex,
    index: props.index,
    invoiceItem: invoice,
    invoiceId: invoice?.invoiceId,
    merchandiseLineItem: lineItem,
    countryOfOrigin: lineItem?.countryOfOrigin,
    hsDataDtl: duty?.hsDataDtl,
    useAggregated: selectUseAggregated(state),
    htsus: duty?.htsus,
    htsDescription: duty?.htsDescription,
    categoryCode: lineItem?.categoryCode,
    grossWeightWeight: lineItem?.grossWeight?.weight,
    grossWeightWeightUnits: lineItem?.grossWeight?.weightUnits,
    invoiceCurrencyValue: duty?.invoiceCurrencyValue || 0.00,
    charges: duty?.charges,
    unitPrice: duty?.unitPrice,
    enteredValueZeroIndex: lineItem?.merchandiseDuties?.[0]?.enteredValue,
    currentEnteredValuex: duty?.enteredValue,
    allDuties: lineItem?.merchandiseDuties,
    adjustedValue: duty?.adjustedValue,
    adjustedValueZeroIndex: lineItem?.merchandiseDuties?.[0]?.adjustedValue,
    merchandiseId: lineItem?.merchandiseId,
    displayErrorForEnteredValue: duty?.displayErrorForEnteredValue,
    merchandiseDutyId: duty?.merchandiseDutyId,
    manifestQuantityQuantity: duty?.manifestQuantity?.quantity,
    invoiceQuantity: duty?.invoiceQuantity?.quantity,
    manifestQuantityUnits: duty?.manifestQuantity?.units,
    invoiceQuantityUnits: duty?.invoiceQuantity?.units,
    additionalQuantityQuantity: duty?.additionalQuantity?.quantity,
    additionalQuantityUnits: duty?.additionalQuantity?.units,
    duty: duty?.duty,
    dutyRate: duty?.dutyRate,
    additionalHtsInfo: duty?.additionalHtsInfo,
    dutyOverrideFlag: duty?.dutyOverrideFlag,
    currentMerchandiseDuty: duty,
    specificRate: duty?.specificRate,
    otherRate: duty?.otherRate,
    isCommodityDuty: duty?.isCommodityDuty,
    adcvd: duty?.adcvd,

    lineValidObjectsBl: selectMerchandiseDutyValidation(
      lineItem?.merchandiseId,
      duty?.merchandiseDutyId
    )(state),
    unitList: state.DropDownValues.unitList || [],
    newValue: state.FormValues.newValue,
    fieldName: state.FormValues.fieldName,
    setINPUTID: state.FormValues.setINPUTID,
    penClicked: state.FormValues.penClicked,
    shipmentId: state.FormValues.shipmentId,
    rbCounterID: state.FormValues.rbCounterID,
    EntryTypeInfo: state.EntryTypeInfo,
    footnote: duty?.hsDataDtl?.footnote || '',

    pgaFlagInfos: lineItem?.pgaFlagInfos || [],
    formDisabled: state.FormValues.formDisabled,
    pscData: state.PSC,
    itDate: state.BOLInfo?.itDate?.epochs,
    entryDate: state.EntryTypeInfo?.summaryDate?.epochs,
    releaseDate: state.EntryTypeInfo?.releaseDate?.epochs,
    importerAdditionalDeclarationDetails: lineItem?.importerAdditionalDeclarationDetails,
    hsDataDtlForThisDuty: duty?.hsDataDtl,
    // Use primary duty additions/deletions so secondary HTS rows show adjusted entered value
    totalAdditions: lineItem?.merchandiseDuties?.[0]?.additions?.totalAdditions,
    totalDeletions: lineItem?.merchandiseDuties?.[0]?.deletions?.totalDeletions
            
  })
}

const mapDispatchToProps = {
  ...actionCreators
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DutyItem)
